// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-25T17:17:49.855Z
// Property: Vantage (ID: 6767906449167729)
// Collections: 12 amenities, 1 floorplans (live), 98 photos, 77 POIs, 1 virtual tours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167729",
  "property_external_id": "1d21rv5",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/vantage-fort-myers-fl/1d21rv5/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "vantage",
  "property_name": "Vantage",
  "property_website_url": "http://vantage-demosite.multiscreensite.com",
  "property_domain": null,
  "property_address": "1500 Carson St",
  "property_full_address": "1500 Carson St, Fort Myers, FL 33901",
  "property_address_1": "500 Carson St",
  "property_address_2": null,
  "property_address_city": "Fort Myers",
  "property_address_state": "FL",
  "property_address_zip_full": null,
  "property_address_zip": "33901",
  "property_address_country": "US",
  "property_address_county": "Lee County",
  "property_neighborhood_address": "Downtown Fort Myers",
  "property_address_latitude": "26.641895",
  "property_address_longitude": "-81.873758",
  "property_email": null,
  "property_phone": "1234567890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Rise above downtown Fort Myers at Vantage.</strong> Elevated two-bedroom apartments pair polished finishes with rooftop relaxation, co-working space, smart home ease, and quick access to the River District energy just outside your door.</p>",
  "property_long_description": "<p><strong>Rise above the River District at Vantage.</strong> From your downtown Fort Myers high-rise, you’re moments from First Street energy, Centennial Park, the Caloosahatchee Riverfront, and the walkable mix of restaurants, cafés, galleries, and performance venues that give the historic River District its character.</p><p>At home, the experience feels elevated from morning to night. Start with a workout in the 11th-floor fitness center, take your laptop to the co-working and conference areas, unwind at the rooftop pool, then settle into the rooftop sky lounge as the city lights come on. Pet-focused conveniences, including a spa and dog wash, plus EV charging, smart home technology, and in-home washers and dryers add everyday ease.</p><p>Inside Vantage’s <a href=\"/floor-plans\">two-bedroom apartments</a>, quartz countertops, stainless steel appliances, wood-style flooring, and tile showers with glass enclosures create a polished, contemporary backdrop. Explore the full <a href=\"/amenities\">amenity collection</a>, then step outside to farmers markets, riverfront events, and the best of downtown living close by.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-771f-75d2-a4cf-864703eba37d.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a modern white apartment building with many balconies under a blue sky.",
    "public_id": "01a0394f-771f-75d2-a4cf-864703eba37d",
    "storage_key": "property/6767906449167729/01a0394f-771f-75d2-a4cf-864703eba37d.webp",
    "width": 1344,
    "height": 895
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "221",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "null",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-4923-7427-9874-81ab14babca2.webp",
  "property_primary_logo_media": {
    "alt_text": "Vantage Edge District St. Pete logo",
    "public_id": "01a0394f-4923-7427-9874-81ab14babca2",
    "storage_key": "property/6767906449167729/01a0394f-4923-7427-9874-81ab14babca2.webp",
    "width": 190,
    "height": 71
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-f0a6-7529-a80b-1e0c009ff3d4.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0394f-f0a6-7529-a80b-1e0c009ff3d4",
    "storage_key": "property/6767906449167729/01a0394f-f0a6-7529-a80b-1e0c009ff3d4.webp",
    "width": 190,
    "height": 71
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-e5d4-766e-9b80-cffef5f5dea0.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0394f-e5d4-766e-9b80-cffef5f5dea0",
    "storage_key": "property/6767906449167729/01a0394f-e5d4-766e-9b80-cffef5f5dea0.webp",
    "width": 190,
    "height": 71
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#218cac",
  "property_secondary_color": "#d55737",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": null,
  "property_bathrooms_range": "1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJLXzuMORB24gRYxcQbGmsXUs",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Vantage",
  "property_home_romance_title": "Experience Unforgettable Moments in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities with an elevated edge.</strong> Start in polished co-working and conference spaces, recharge in the 11th-floor fitness center, then unwind above downtown Fort Myers at the rooftop pool and sky lounge. Apartment interiors bring the same refined feel with quartz countertops, stainless steel appliances, wood-style flooring, smart home features, in-home laundry, and glass-enclosed tile showers—plus practical extras like EV charging and a pet spa with dog wash.</p>",
  "property_home_floorplans_blurb": "<p><strong>Two-bedroom layouts with a downtown point of view.</strong> Open living areas, polished kitchens, and well-defined bedroom space make Vantage easy to compare and easy to picture. Explore available floor plans with quartz countertops, stainless steel appliances, wood-style flooring, smart home technology, in-home washers and dryers, and tile showers with glass enclosures—all in the heart of Fort Myers.</p>",
  "property_home_gallery_blurb": "<p><strong>See the high-rise view.</strong> Get a closer look at Vantage through sunlit interiors, sleek quartz kitchens, stainless steel appliances, wood-style flooring, and glass-enclosed tile showers. Then head upstairs in the gallery for rooftop pool scenes, sky lounge moments above downtown Fort Myers, an 11th-floor fitness center, co-working spaces, and the pet spa—all captured to help you picture life from every angle.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Downtown Fort Myers is right downstairs.</strong> Step from Vantage into the River District’s brick-lined blocks for coffee, dinner at Oxbow Bar &amp; Grill or The Veranda, a slice from Downtown House of Pizza, and nights at Florida Repertory Theatre or the Sidney &amp; Berne Davis Art Center. Waterfront paths, public art, historic architecture, and LeeTran connections make it easy to explore—then return to elevated views and everyday ease above it all.</p>",
  "property_home_reviews_blurb": "<p><strong>Hear what life at Vantage is really like.</strong> Resident reviews offer a closer look at the everyday details that matter after move-in—from first impressions to the moments that shape day-to-day living at 1500 Carson St. Explore the comments, compare recurring themes, and see what stands out as you consider Vantage in Fort Myers.</p>",
  "property_neighborhood_blurb": "<p><strong>Downtown starts at street level.</strong> From Vantage, you can step into the River District’s brick-lined blocks and let the day unfold one stop at a time: coffee before the map loads, dinner at Oxbow Bar &amp; Grill or The Veranda, a slice from Downtown House of Pizza, then a show at Florida Repertory Theatre or an evening at the Sidney &amp; Berne Davis Art Center. Waterfront paths, public art, historic architecture, and LeeTran connections keep the neighborhood easy to explore, while McGregor Boulevard puts Edison and Ford Winter Estates close for a change of pace. Use the map to find what is nearby, then come back up to the views, finishes, and everyday ease you’ll see throughout the <a href=\"/gallery\">Vantage photo gallery</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces with a higher point of view.</strong> At Vantage, your day can move from focused to relaxed without leaving the building: settle into the co-working and conference areas, recharge in the 11th-floor fitness center, then head up to the rooftop pool or sky lounge when it’s time to unwind above downtown Fort Myers.</p><p>Inside your apartment, clean modern finishes keep the experience just as polished. Quartz countertops, stainless steel appliances, wood-style flooring, smart home technology, in-home laundry, and tile showers with glass enclosures bring comfort and function into the everyday details. Add conveniences like EV charging and a pet spa with dog wash, and Vantage’s amenities feel designed around real routines—not just a checklist. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see them up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready to rise above downtown Fort Myers?</strong> Vantage pairs polished two-bedroom apartment finishes with elevated spaces like the rooftop pool, sky lounge, co-working areas, and 11th-floor fitness center. If this feels like the right fit, start your online application today and take the next step toward calling Vantage home.</p>",
  "property_contactus_blurb": "<p><strong>Connect with Vantage.</strong> Have questions about our downtown Fort Myers high-rise, two-bedroom apartments, or elevated amenity spaces? Reach out to the leasing team for details, next steps, or directions to 1500 Carson St—we’re here to help you find your way to Vantage.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Vantage?</strong> Find quick answers about the community, leasing, amenities, and everyday living in this downtown Fort Myers high-rise. If you need more details, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find your two-bedroom vantage point.</strong> Vantage’s floor plans are designed for the way you move through the day, with open living areas, polished kitchens, and bedroom space that gives each room a clear purpose. Compare available two-bedroom layouts, check current pricing, and see which home gives you room to work, unwind, or simply spread out in downtown Fort Myers.</p><p>Inside, quartz countertops, stainless steel appliances, wood-style flooring, smart home technology, and in-home washers and dryers bring a clean, modern rhythm to daily routines, while tile showers with glass enclosures add a finished high-rise feel. Once you find a layout you like, browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details up close.</p>",
  "property_gallery_blurb": "<p><strong>See Vantage from every angle.</strong> Browse a gallery that brings the high-rise experience into focus: sunlit two-bedroom interiors, sleek kitchens with quartz countertops and stainless steel appliances, and wood-style flooring that gives each room a warm, modern frame. Detail shots reveal the polished touches too, from glass-enclosed tile showers to smart home conveniences designed to blend into the background.</p><p>Then follow the camera upward. Photos of the rooftop pool and sky lounge capture open-air moments above downtown Fort Myers, while the 11th-floor fitness center, co-working areas, and pet spa show how daily routines can look at Vantage. Like what you see? Explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to take in the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Vantage from every angle.</strong> Use the interactive map to browse available apartments and see how downtown Fort Myers living connects you to the River District’s restaurants, cafés, galleries, performance venues, and riverfront energy just moments from home.</p>",
  "property_pets_blurb": "<p><strong>Pet routines feel easier when cleanup is built in.</strong> At Vantage, you can keep bath-time splashes outside your apartment with an on-site pet spa and dog wash, then return to a home with wood-style flooring and in-home laundry that supports everyday life with pets.</p><p>From quick downtown Fort Myers walks to dog-friendly patios and off-leash outings nearby, your day has room for fresh air, treats, and a cleaner return home. Review the current pet policy details on this page for fees, limits, and restrictions, then explore more <a href=\"/amenities\">community amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the pet-focused conveniences in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share your Vantage view.</strong><br>Love the rooftop pool, sky lounge, 11th-floor fitness center, and downtown high-rise energy? Invite a friend to discover the elevated Fort Myers lifestyle you already know—and help them find their place at Vantage.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Vantage.</strong><br>Keep everyday living elevated with quick online tools to pay rent, submit maintenance requests, and manage account details—all in one convenient place.</p>",
  "property_reviews_blurb": "<p><strong>See Vantage through resident reviews.</strong> As you explore the ratings and comments below, you’ll get a practical look at everyday life at 1500 Carson St—from the details people notice after move-in to the moments that shape their experience over time. Use these reviews to compare impressions, spot recurring themes, and feel more confident as you consider Vantage for your next home in Fort Myers.</p>",
  "property_created_at": "1787667846021",
  "property_scheduletour_blurb": "<p><strong>See Vantage from a higher point of view.</strong> Tour downtown Fort Myers high-rise living with polished two-bedroom interiors, rooftop spaces, co-working areas, and everyday conveniences designed to elevate the routine. Explore the <a href=\"/amenities\">amenity collection</a>, then schedule your in-person visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Vantage’s leasing team will be in touch soon. In the meantime, picture elevated downtown Fort Myers living with rooftop spaces, smart home ease, polished two-bedroom interiors, and the River District’s energy just moments from home.</p>",
  "property_virtualtours_blurb": "<p><strong>Start with the walkthrough—not the commute.</strong> Take a virtual look inside Vantage’s two-bedroom, one-bath apartment and get a feel for the layout before you visit in person. Move from the living area to the kitchen, picture how the open space connects, and zoom in on the finishes that shape daily life: quartz countertops, stainless steel appliances, wood-style flooring, smart home technology, in-home laundry, and a tile shower with a glass enclosure.</p><p>This tour lets you slow down, replay the details, and decide what you want to see next at Vantage in Downtown Fort Myers. When you’re ready, <a href=\"/floor-plans\">compare floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_copyright": "2026 All Rights Reserved. Vantage",
  "property_seo_title_home": "Vantage |  Apartments in Fort Myers, FL",
  "property_seo_description_home": "Elevate your lifestyle at Vantage in Fort Myers, FL. Enjoy modern amenities, from a rooftop pool to a pet spa. Your dream apartment awaits!",
  "property_seo_title_floorplans": "Floor Plans | Fort Myers, FL Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Vantage in Fort Myers, FL! Browse our two-bedroom floor plans and find your perfect space for comfort and convenience.",
  "property_seo_title_amenities": "Amenities | Fort Myers, FL Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Vantage in Fort Myers. Enjoy a rooftop pool, fitness center, pet spa, and modern finishes that redefine apartment living.",
  "property_seo_title_gallery": "Gallery | Apartments in Fort Myers, FL",
  "property_seo_description_gallery": "Capture the essence of luxury at Vantage in Fort Myers! Scroll through our photo gallery and envision rooftop lounges, chic amenities, and modern living.",
  "property_seo_title_virtualtours": "Virtual Tours | Vantage Apartments",
  "property_seo_description_virtualtours": "Step inside Vantage in Fort Myers, FL. Experience our spacious two-bedroom apartments through a virtual tour. See your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Vantage Apartments",
  "property_seo_description_interactivemap": "Discover your ideal two-bedroom apartment at Vantage in Fort Myers, FL! Explore our interactive map for stunning amenities and modern features!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Fort Myers, FL",
  "property_seo_description_neighborhood": "Experience vibrant living at Vantage in Fort Myers, FL! Uncover local favorites and nearby attractions just steps away from your two-bedroom haven. Join us!",
  "property_seo_title_contact": "Contact Us | Vantage",
  "property_seo_description_contact": "Find your perfect two-bedroom home at Vantage in Fort Myers, FL. Have questions? Reach out to our leasing team today for personalized assistance!",
  "property_seo_title_faqs": "FAQs | Apartments in Fort Myers, FL",
  "property_seo_description_faqs": "Elevate your living at Vantage in Fort Myers! Discover luxurious amenities like a rooftop pool and smart home tech.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Fort Myers, FL",
  "property_seo_description_reviews": "Experience life at Vantage in Fort Myers, where luxury meets comfort. Check out our residents’ thoughts on rooftop pools, state-of-the-art amenities, and more!",
  "property_seo_title_applynow": "Apply Now | Apartments in Fort Myers, FL",
  "property_seo_description_applynow": "Elevate your lifestyle at Vantage Fort Myers! Enjoy luxury 2-bedrooms, a rooftop lounge, fitness center, and smart home features. Apply online!",
  "property_seo_title_residentaccess": "Resident Access | Vantage",
  "property_seo_description_residentaccess": "Elevate your living at Vantage in Fort Myers. Log in to your resident portal for easy rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Vantage",
  "property_seo_description_referafriend": "Great friends make the best neighbors! Refer a friend to Vantage in Fort Myers and enjoy vibrant living together. Join our community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Vantage",
  "property_seo_description_scheduletour": "Experience Vantage in Fort Myers! Immerse yourself in modern living with luxurious amenities. Schedule your tour today and envision your new home!",
  "property_seo_title_privacy": "Privacy Policy | Vantage",
  "property_seo_description_privacy": "Your privacy matters at Vantage in Fort Myers, FL. Learn how we protect your information with our detailed privacy policy. View it now for peace of mind!",
  "property_seo_title_accessibility": "Website Accessibility | Vantage",
  "property_seo_description_accessibility": "At Vantage in Fort Myers, we prioritize digital inclusion. Discover our commitment to accessibility for all residents and visitors. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Vantage",
  "property_seo_description_sitemap": "Uncover Vantage in Fort Myers, FL—where modern living meets comfort. Navigate via our sitemap to find your perfect apartment retreat today!",
  "property_seo_title_thankyou": "Thank You | Vantage",
  "property_seo_description_thankyou": "Thank you for reaching out to Vantage in Fort Myers! Our team will be in touch soon to help you find your perfect apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Fort Myers, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787677671137",
  "amenities": [
    {
      "id": "ec_4994ab57d5120a2594b52f31",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "rooftop sky lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_963e2c06d8625bf678aa210b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "rooftop pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31c9bd2fb21a62dd6b526459",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "11th floor fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b8c2a691efa1f4c259a0dfa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "pet spa and dog wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d391926228d405c293e0b762",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "electric car charging station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b2830a67e6a35be69733bf9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "co‑working and conference areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1767f995c5c06143a4a495b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "quarts countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b68f8fe31d551fae49e7c74",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "wood‑style flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9a023abd63917eaf2fc4b04",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "tile showers with glass enclosures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bea6fd78e27309475678ed01",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "stainless steel appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10af2d2fe9441871cf96200b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "smart home technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9ebbe02573b5d4f46ae514e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "external_id": "false",
      "title": "in home washers & dryers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_7ad9e4accea18a72d945df29",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-4923-7427-9874-81ab14babca2.webp",
      "image_media": {
        "alt_text": "Vantage Edge District St. Pete logo",
        "public_id": "01a0394f-4923-7427-9874-81ab14babca2",
        "storage_key": "property/6767906449167729/01a0394f-4923-7427-9874-81ab14babca2.webp",
        "width": 190,
        "height": 71
      },
      "title": "Logo",
      "description": "The Vantage Edge District St. Pete logo in white on a black background.",
      "link": "false",
      "alt_text": "Vantage Edge District St. Pete logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/vantage-logo-white-padded-266x100-191w.png"
    },
    {
      "id": "ec_7ab4779efe4bb0446917322b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-49b9-76a4-9d71-9772db84d10e.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances, sleek cabinetry, and a gray countertop.",
        "public_id": "01a0394f-49b9-76a4-9d71-9772db84d10e",
        "storage_key": "property/6767906449167729/01a0394f-49b9-76a4-9d71-9772db84d10e.webp",
        "width": 450,
        "height": 300
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this beautifully appointed apartment kitchen, featuring stainless steel appliances, ample counter space, and contemporary cabinetry.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with stainless steel appliances, sleek cabinetry, and a gray countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_08-1299x866-450w.jpg"
    },
    {
      "id": "ec_fe2771ab1c3c71370e3e5f3d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-4998-7743-8d2b-7b2b73e9ba96.webp",
      "image_media": {
        "alt_text": "Modern studio apartment living room and kitchen with murphy bed",
        "public_id": "01a0394f-4998-7743-8d2b-7b2b73e9ba96",
        "storage_key": "property/6767906449167729/01a0394f-4998-7743-8d2b-7b2b73e9ba96.webp",
        "width": 450,
        "height": 300
      },
      "title": "Apartment",
      "description": "Spacious studio apartment featuring a modern kitchen with stainless steel appliances and a comfortable living area with a murphy bed, perfect for maximizing space.",
      "link": "false",
      "alt_text": "Modern studio apartment living room and kitchen with murphy bed",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_07-1294x863-450w.jpg"
    },
    {
      "id": "ec_46f792e6ebbe2a1cd168fac9",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-4a15-727a-aa07-5ec111c1f24f.webp",
      "image_media": {
        "alt_text": "Living room with a brown leather sofa, coffee table, desk, and large artwork on the wall.",
        "public_id": "01a0394f-4a15-727a-aa07-5ec111c1f24f",
        "storage_key": "property/6767906449167729/01a0394f-4a15-727a-aa07-5ec111c1f24f.webp",
        "width": 450,
        "height": 300
      },
      "title": "Apartment",
      "description": "A stylish living room featuring a tufted leather sofa, a modern coffee table, and a statement piece of wall art. The space is well-lit with large windows, offering a view of the outdoors.",
      "link": "false",
      "alt_text": "Living room with a brown leather sofa, coffee table, desk, and large artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_14-1344x896-450w.jpg"
    },
    {
      "id": "ec_df74187374bb5fb35ded93a0",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-49cf-753d-99ee-4ef20e8b87e9.webp",
      "image_media": {
        "alt_text": "Modern living room with tufted sofa, armchairs, coffee table, and large windows.",
        "public_id": "01a0394f-49cf-753d-99ee-4ef20e8b87e9",
        "storage_key": "property/6767906449167729/01a0394f-49cf-753d-99ee-4ef20e8b87e9.webp",
        "width": 450,
        "height": 300
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this spacious living area, featuring a tufted sofa, comfortable armchairs, and large windows with city views.",
      "link": "false",
      "alt_text": "Modern living room with tufted sofa, armchairs, coffee table, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_12-1344x896-450w.jpg"
    },
    {
      "id": "ec_cb6ba4c04bb054b2c616e348",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-499c-774b-b94a-b9e573e3413d.webp",
      "image_media": {
        "alt_text": "Murphy bed with mattress pulled down, gray headboard, in a studio apartment living space.",
        "public_id": "01a0394f-499c-774b-b94a-b9e573e3413d",
        "storage_key": "property/6767906449167729/01a0394f-499c-774b-b94a-b9e573e3413d.webp",
        "width": 450,
        "height": 300
      },
      "title": "Apartment",
      "description": "This studio apartment features a space-saving Murphy bed, perfect for maximizing living space. Enjoy a comfortable and stylish living area.",
      "link": "false",
      "alt_text": "Murphy bed with mattress pulled down, gray headboard, in a studio apartment living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_10-1344x896-450w.jpg"
    },
    {
      "id": "ec_2c100b30b02717bbff3635c1",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-48f0-71aa-8d94-a91bf1ff226d.webp",
      "image_media": {
        "alt_text": "Vantage logo on a black background",
        "public_id": "01a0394f-48f0-71aa-8d94-a91bf1ff226d",
        "storage_key": "property/6767906449167729/01a0394f-48f0-71aa-8d94-a91bf1ff226d.webp",
        "width": 521,
        "height": 194
      },
      "title": "Logo",
      "description": "The official logo for Vantage, featuring a stylized 'V' and the word 'VANTAGE' in white text against a black background.",
      "link": "false",
      "alt_text": "Vantage logo on a black background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/opt/Top-Tips-to-Reduce-Cumulative-Layout-Shift--28CLS-29-and-Enhance-User-Experience--281-29-1920w.png"
    },
    {
      "id": "ec_87676eff9df58e9cecf8dc4d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-485c-703e-9da7-ea8268442c3e.webp",
      "image_media": {
        "alt_text": "Black screen",
        "public_id": "01a0394f-485c-703e-9da7-ea8268442c3e",
        "storage_key": "property/6767906449167729/01a0394f-485c-703e-9da7-ea8268442c3e.webp",
        "width": 500,
        "height": 500
      },
      "title": "Other",
      "description": "secondary-image",
      "link": "false",
      "alt_text": "secondary-image",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/opt/Untitled+design-1920w.png"
    },
    {
      "id": "ec_1f0333a7d99d493f5fb3436f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-48d5-75cf-b50c-a8146bfb537d.webp",
      "image_media": {
        "alt_text": "Calendar icon",
        "public_id": "01a0394f-48d5-75cf-b50c-a8146bfb537d",
        "storage_key": "property/6767906449167729/01a0394f-48d5-75cf-b50c-a8146bfb537d.webp",
        "width": 52,
        "height": 52
      },
      "title": "Other",
      "description": "Calendar icon representing dates or scheduling.",
      "link": "false",
      "alt_text": "Calendar icon",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/banner_icon1-52x52-62w.png"
    },
    {
      "id": "ec_e534860147fb0185c04d2541",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-48b9-745c-88cd-7220bcf27acc.webp",
      "image_media": {
        "alt_text": "Vantage Edge District / St. Pete logo",
        "public_id": "01a0394f-48b9-745c-88cd-7220bcf27acc",
        "storage_key": "property/6767906449167729/01a0394f-48b9-745c-88cd-7220bcf27acc.webp",
        "width": 266,
        "height": 100
      },
      "title": "Logo",
      "description": "The Vantage Edge District / St. Pete logo featuring a stylized 'V' and the property name.",
      "link": "false",
      "alt_text": "Vantage Edge District / St. Pete logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp-cdn.multiscreensite.com/0852a398/import/clib/vantagestpete_com/dms3rep/multi/vantage-logo-white-padded-266x100.png"
    },
    {
      "id": "ec_ce96a0cea1fe4162e5e2b7b5",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-513c-709d-a3ab-de543304ccad.webp",
      "image_media": {
        "alt_text": "Multihub logo",
        "public_id": "01a0394f-513c-709d-a3ab-de543304ccad",
        "storage_key": "property/6767906449167729/01a0394f-513c-709d-a3ab-de543304ccad.webp",
        "width": 1920,
        "height": 284
      },
      "title": "Logo",
      "description": "The official logo for Multihub, featuring a colorful gradient from purple to orange.",
      "link": "false",
      "alt_text": "Multihub logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/Multihub+Logo+Color+%281%29.png"
    },
    {
      "id": "ec_3d2871fadb6814eb039ecc90",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5152-721e-bc30-c9349c9eaee2.webp",
      "image_media": {
        "alt_text": "Repli logo",
        "public_id": "01a0394f-5152-721e-bc30-c9349c9eaee2",
        "storage_key": "property/6767906449167729/01a0394f-5152-721e-bc30-c9349c9eaee2.webp",
        "width": 1014,
        "height": 496
      },
      "title": "Logo",
      "description": "The Repli logo features the word 'repli' in a stylized white font on a black background. The 'i' has a gradient circle above it.",
      "link": "false",
      "alt_text": "Repli logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/Repli_White-logo-gradient-dot-41918591-1920w.webp"
    },
    {
      "id": "ec_a13214715fa0ab21107c5329",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5295-7248-84b5-dca93ff160e6.webp",
      "image_media": {
        "alt_text": "Vantage Edge District St. Pete logo",
        "public_id": "01a0394f-5295-7248-84b5-dca93ff160e6",
        "storage_key": "property/6767906449167729/01a0394f-5295-7248-84b5-dca93ff160e6.webp",
        "width": 266,
        "height": 100
      },
      "title": "Logo",
      "description": "The Vantage Edge District St. Pete logo featuring the Vantage stylized V and the property name and location.",
      "link": "false",
      "alt_text": "Vantage Edge District St. Pete logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/vantage-logo-white-padded-266x100-1920w.png"
    },
    {
      "id": "ec_515867b43ebc2497b4dc2f27",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5403-7139-aabd-95f066163216.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, including a refrigerator, microwave, and oven, as well as sleek cabinets and a large sink.",
        "public_id": "01a0394f-5403-7139-aabd-95f066163216",
        "storage_key": "property/6767906449167729/01a0394f-5403-7139-aabd-95f066163216.webp",
        "width": 1299,
        "height": 866
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this spacious and modern kitchen, complete with stainless steel appliances, ample cabinet space, and a large sink.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, including a refrigerator, microwave, and oven, as well as sleek cabinets and a large sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_08-1299x866-1920w.jpg"
    },
    {
      "id": "ec_be37bb1b68e9821f05c3fa13",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-4998-7743-8d2b-7b2b73e9ba96.webp",
      "image_media": {
        "alt_text": "Modern studio apartment with murphy bed, living area, and full kitchen.",
        "public_id": "01a0394f-4998-7743-8d2b-7b2b73e9ba96",
        "storage_key": "property/6767906449167729/01a0394f-4998-7743-8d2b-7b2b73e9ba96.webp",
        "width": 1294,
        "height": 863
      },
      "title": "Apartment",
      "description": "Stylish studio apartment featuring a pull-down murphy bed, comfortable living area, and a sleek, fully equipped kitchen with stainless steel appliances and bar seating.",
      "link": "false",
      "alt_text": "Modern studio apartment with murphy bed, living area, and full kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_07-1294x863-1920w.jpg"
    },
    {
      "id": "ec_d748a07bfee1e96e5d8a5f63",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-54ec-73ab-ac72-e2f12fb5536c.webp",
      "image_media": {
        "alt_text": "Luxurious living room with leather couch, coffee table, and modern art.",
        "public_id": "01a0394f-54ec-73ab-ac72-e2f12fb5536c",
        "storage_key": "property/6767906449167729/01a0394f-54ec-73ab-ac72-e2f12fb5536c.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this beautifully appointed apartment living room, featuring a plush leather sofa, stylish coffee table, and captivating modern art.",
      "link": "false",
      "alt_text": "Luxurious living room with leather couch, coffee table, and modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_14-1344x896-1920w.jpg"
    },
    {
      "id": "ec_11489ab7fa6fcf543afff494",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-55f1-76a0-8c8c-1e7fa5ed9816.webp",
      "image_media": {
        "alt_text": "Modern living room with a tufted leather sofa, two armchairs, and large windows.",
        "public_id": "01a0394f-55f1-76a0-8c8c-1e7fa5ed9816",
        "storage_key": "property/6767906449167729/01a0394f-55f1-76a0-8c8c-1e7fa5ed9816.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Stylish and inviting living room featuring a plush leather sofa, comfortable armchairs, and ample natural light pouring in through expansive windows.",
      "link": "false",
      "alt_text": "Modern living room with a tufted leather sofa, two armchairs, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_12-1344x896-1920w.jpg"
    },
    {
      "id": "ec_bfaa9240114dd96fa1bfc992",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5654-737f-8909-80ddb9cb72d9.webp",
      "image_media": {
        "alt_text": "Murphy bed pulled down in a studio apartment with a chair and coffee table.",
        "public_id": "01a0394f-5654-737f-8909-80ddb9cb72d9",
        "storage_key": "property/6767906449167729/01a0394f-5654-737f-8909-80ddb9cb72d9.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Maximize your space with a murphy bed in this studio apartment. Features a modern design with a comfortable mattress, perfect for multi-functional living.",
      "link": "false",
      "alt_text": "Murphy bed pulled down in a studio apartment with a chair and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/Web-Vantage_10-1344x896-1920w.jpg"
    },
    {
      "id": "ec_310e95f2b34ed40dd9fde6a5",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-578f-710e-b3be-03a17c31eaf4.webp",
      "image_media": {
        "alt_text": "Calendar icon",
        "public_id": "01a0394f-578f-710e-b3be-03a17c31eaf4",
        "storage_key": "property/6767906449167729/01a0394f-578f-710e-b3be-03a17c31eaf4.webp",
        "width": 52,
        "height": 52
      },
      "title": "Other",
      "description": "Icon representing a calendar, often used for scheduling or important dates.",
      "link": "false",
      "alt_text": "Calendar icon",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/banner_icon1-52x52-1920w.png"
    },
    {
      "id": "ec_f5c69474b4ff5007e5c8244b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5dfb-7658-9b1d-b1ca7b23a6c3.webp",
      "image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and seating areas.",
        "public_id": "01a0394f-5dfb-7658-9b1d-b1ca7b23a6c3",
        "storage_key": "property/6767906449167729/01a0394f-5dfb-7658-9b1d-b1ca7b23a6c3.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Pool",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Pool",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_13-1-1920w.jpg"
    },
    {
      "id": "ec_c6ab5332bf418b3e3220c92b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-601e-707c-80c2-b4784b90c86c.webp",
      "image_media": {
        "alt_text": "Rooftop pool and lounge area with city views.",
        "public_id": "01a0394f-601e-707c-80c2-b4784b90c86c",
        "storage_key": "property/6767906449167729/01a0394f-601e-707c-80c2-b4784b90c86c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Poolside Lounge with Sofa",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Poolside Lounge with Sofa",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Pool-by-Rob-Harris-scaled-1920w.jpg"
    },
    {
      "id": "ec_a0691715c49acce23b4f1e1a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-6087-73c9-985a-6f113ad7fa6b.webp",
      "image_media": {
        "alt_text": "Gym with weight rack, punching bag, and medicine balls.",
        "public_id": "01a0394f-6087-73c9-985a-6f113ad7fa6b",
        "storage_key": "property/6767906449167729/01a0394f-6087-73c9-985a-6f113ad7fa6b.webp",
        "width": 1628,
        "height": 1085
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Fitness Center",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Fitness Center",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_19-1-1920w.jpg"
    },
    {
      "id": "ec_d7c83427ecfcb1ba0fe2b4d7",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-6087-73c9-985a-7106c8b35327.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, stationary bikes, rowing machine, and weight training equipment.",
        "public_id": "01a0394f-6087-73c9-985a-7106c8b35327",
        "storage_key": "property/6767906449167729/01a0394f-6087-73c9-985a-7106c8b35327.webp",
        "width": 1636,
        "height": 1091
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Fitness Center with Treadmills",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Fitness Center with Treadmills",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_18-1920w.jpg"
    },
    {
      "id": "ec_e93d9b973f6b1090a8220f07",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-62f0-7451-a337-26b3540c5344.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with weight machines, free weights, and mirrors.",
        "public_id": "01a0394f-62f0-7451-a337-26b3540c5344",
        "storage_key": "property/6767906449167729/01a0394f-62f0-7451-a337-26b3540c5344.webp",
        "width": 1634,
        "height": 1090
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Fitness Center with Weights",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Fitness Center with Weights",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_17-1920w.jpg"
    },
    {
      "id": "ec_4b9b92fe64be4b8dd2624df4",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-6284-70eb-b769-534b888d06a5.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a long communal table and bar stools, plush seating, and decorative lighting.",
        "public_id": "01a0394f-6284-70eb-b769-534b888d06a5",
        "storage_key": "property/6767906449167729/01a0394f-6284-70eb-b769-534b888d06a5.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Conference And Event Areas",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Conference And Event Areas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Dining-1-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_9431cb7d383727967dc90e16",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-62ef-740f-a5a6-3f4eb5a09b50.webp",
      "image_media": {
        "alt_text": "Modern lounge area with teal banquettes, a communal table, and abstract art.",
        "public_id": "01a0394f-62ef-740f-a5a6-3f4eb5a09b50",
        "storage_key": "property/6767906449167729/01a0394f-62ef-740f-a5a6-3f4eb5a09b50.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Resident Lounge with Sofa",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Resident Lounge with Sofa",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Dining-2-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_389e1de9521e18806c64ca82",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-6541-724b-8c62-409f01629c2c.webp",
      "image_media": {
        "alt_text": "Modern lounge area with fireplace and comfortable seating.",
        "public_id": "01a0394f-6541-724b-8c62-409f01629c2c",
        "storage_key": "property/6767906449167729/01a0394f-6541-724b-8c62-409f01629c2c.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Resident Lounge with Modern Industrial Decor",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Resident Lounge with Modern Industrial Decor",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-VIP-1-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_e22142810db7bdfda226a63f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-650b-72bf-b3a9-92635b8815b6.webp",
      "image_media": {
        "alt_text": "Modern apartment building lobby with seating areas, artwork, and plants.",
        "public_id": "01a0394f-650b-72bf-b3a9-92635b8815b6",
        "storage_key": "property/6767906449167729/01a0394f-650b-72bf-b3a9-92635b8815b6.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Reception Area",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Reception Area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Reception-Area-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_579860c7bc7e117416c40ce7",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-654b-738b-b9c4-4507b37e3890.webp",
      "image_media": {
        "alt_text": "Modern living area with stylish furniture, bookshelves, and a dining area visible through an opening.",
        "public_id": "01a0394f-654b-738b-b9c4-4507b37e3890",
        "storage_key": "property/6767906449167729/01a0394f-654b-738b-b9c4-4507b37e3890.webp",
        "width": 1304,
        "height": 869
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Resident Lounge",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Resident Lounge",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_04-1-1920w.jpg"
    },
    {
      "id": "ec_9459d98b195b80c674fcdb37",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-6e4f-72aa-b1d8-4d4fb4a8b503.webp",
      "image_media": {
        "alt_text": "Conference room with round table and chairs, television, and modern light fixture.",
        "public_id": "01a0394f-6e4f-72aa-b1d8-4d4fb4a8b503",
        "storage_key": "property/6767906449167729/01a0394f-6e4f-72aa-b1d8-4d4fb4a8b503.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Resident Lounge with TV",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Resident Lounge with TV",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_06-1920w.jpg"
    },
    {
      "id": "ec_67b3a4f5226274695630989a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-6fad-7509-b822-40060b31cd2f.webp",
      "image_media": {
        "alt_text": "Modern lounge area with curved green velvet sofa and unique bubble chandeliers.",
        "public_id": "01a0394f-6fad-7509-b822-40060b31cd2f",
        "storage_key": "property/6767906449167729/01a0394f-6fad-7509-b822-40060b31cd2f.webp",
        "width": 1344,
        "height": 1635
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Resident Lounge with Seating Area",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Resident Lounge with Seating Area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-VIP-2-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_b3a34a93ec75d9b8c0657ca9",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7154-7048-8a36-911ee256810c.webp",
      "image_media": {
        "alt_text": "Modern communal bathroom with a large abstract painting and a long vanity with multiple sinks.",
        "public_id": "01a0394f-7154-7048-8a36-911ee256810c",
        "storage_key": "property/6767906449167729/01a0394f-7154-7048-8a36-911ee256810c.webp",
        "width": 1344,
        "height": 903
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Resident Lounge Bathroom",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Resident Lounge Bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Womens-Bathroom-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_4c6566e6f5ce9e09001ca12a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-71e5-74da-a1a0-3563c15fb6e4.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with dining table, chairs, and kitchenette.",
        "public_id": "01a0394f-71e5-74da-a1a0-3563c15fb6e4",
        "storage_key": "property/6767906449167729/01a0394f-71e5-74da-a1a0-3563c15fb6e4.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Conference Area",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Conference Area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_03-1-1920w.jpg"
    },
    {
      "id": "ec_6a1bd6f6dc2f328e4daa32f5",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7287-7603-a6c9-c3b3aaa9df9c.webp",
      "image_media": {
        "alt_text": "Modern apartment lobby with stylish seating and decorative wall.",
        "public_id": "01a0394f-7287-7603-a6c9-c3b3aaa9df9c",
        "storage_key": "property/6767906449167729/01a0394f-7287-7603-a6c9-c3b3aaa9df9c.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Reception Lounge",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Reception Lounge",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_01-1-1920w.jpg"
    },
    {
      "id": "ec_0eb7c21f49385e66efe349df",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-73f6-73ff-a8df-0119c1727dec.webp",
      "image_media": {
        "alt_text": "Starbucks coffee machine with touch screen and cup dispenser",
        "public_id": "01a0394f-73f6-73ff-a8df-0119c1727dec",
        "storage_key": "property/6767906449167729/01a0394f-73f6-73ff-a8df-0119c1727dec.webp",
        "width": 896,
        "height": 1344
      },
      "title": "Other",
      "description": "Vantage St. Pete Apartment Coffee Station",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Coffee Station",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_05-1920w.jpg"
    },
    {
      "id": "ec_2ef0b6809a2253d03c4ac255",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-74cd-7268-b101-6bb5032c5cea.webp",
      "image_media": {
        "alt_text": "Mailroom with mailboxes and a seating area with a table and chairs.",
        "public_id": "01a0394f-74cd-7268-b101-6bb5032c5cea",
        "storage_key": "property/6767906449167729/01a0394f-74cd-7268-b101-6bb5032c5cea.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Mail Room",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Mail Room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Mail-Room-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_2ae23f54b288cef347a6549f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7532-707c-8aff-b5bc87ccdfba.webp",
      "image_media": {
        "alt_text": "Hallway with abstract wireframe sculptures of people inside geometric shapes on the wall.",
        "public_id": "01a0394f-7532-707c-8aff-b5bc87ccdfba",
        "storage_key": "property/6767906449167729/01a0394f-7532-707c-8aff-b5bc87ccdfba.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Art Hallway",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Art Hallway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-BW-Art-Hallway-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_99dcdf905b163d6c6e87148b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-771f-75d2-a4cf-864703eba37d.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern white apartment building with many balconies under a blue sky.",
        "public_id": "01a0394f-771f-75d2-a4cf-864703eba37d",
        "storage_key": "property/6767906449167729/01a0394f-771f-75d2-a4cf-864703eba37d.webp",
        "width": 1344,
        "height": 895
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Exterior View",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Exterior View",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Ext-2-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_671ca26a6624fc99c9f141e1",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7921-754b-afd5-4c827393ef5a.webp",
      "image_media": {
        "alt_text": "Hallway with black and white city map mural and elevators.",
        "public_id": "01a0394f-7921-754b-afd5-4c827393ef5a",
        "storage_key": "property/6767906449167729/01a0394f-7921-754b-afd5-4c827393ef5a.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Elevator Lobby",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Elevator Lobby",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Elevator-Lobby-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_a7b19dab72f637dc6c3b57f2",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7d21-72a2-8bf5-87a85e7087f3.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior at dusk with balconies and streetlights.",
        "public_id": "01a0394f-7d21-72a2-8bf5-87a85e7087f3",
        "storage_key": "property/6767906449167729/01a0394f-7d21-72a2-8bf5-87a85e7087f3.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Building View",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Building View",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/HIGH-RES-Vantage-Ext-Twilight-by-Rob-Harris-1-1920w.jpg"
    },
    {
      "id": "ec_e454ca7aac55355e79e5cd6b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7ea9-7275-81cb-efbbc09a568c.webp",
      "image_media": {
        "alt_text": "Street view of colorful storefronts and a white SUV.",
        "public_id": "01a0394f-7ea9-7275-81cb-efbbc09a568c",
        "storage_key": "property/6767906449167729/01a0394f-7ea9-7275-81cb-efbbc09a568c.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Neighborhood",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Neighborhood",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_40-1920w.jpg"
    },
    {
      "id": "ec_5fb2cb02562bb495d59842cc",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7f09-77af-94a9-83a0486fc0af.webp",
      "image_media": {
        "alt_text": "Exterior view of a pink building with a flamingo mural and neon sign, featuring an outdoor patio area.",
        "public_id": "01a0394f-7f09-77af-94a9-83a0486fc0af",
        "storage_key": "property/6767906449167729/01a0394f-7f09-77af-94a9-83a0486fc0af.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Surrounding Neighborhood",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Surrounding Neighborhood",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_42-1920w.jpg"
    },
    {
      "id": "ec_bf80f7671326ce939c92da98",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-81e0-760f-be84-186857d2ae91.webp",
      "image_media": {
        "alt_text": "Green Bench Brewing Co. building exterior with a silo and vibrant citrus mural.",
        "public_id": "01a0394f-81e0-760f-be84-186857d2ae91",
        "storage_key": "property/6767906449167729/01a0394f-81e0-760f-be84-186857d2ae91.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Vantage St. Pete Apartment Neighborhood Vender",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Neighborhood Vender",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_45-1920w.jpg"
    },
    {
      "id": "ec_31bcf3e4f00b7bf878ca62af",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-8198-755b-afa3-59ad0105e445.webp",
      "image_media": {
        "alt_text": "Yellow entrance sign for the Museum of Fine Arts St. Petersburg.",
        "public_id": "01a0394f-8198-755b-afa3-59ad0105e445",
        "storage_key": "property/6767906449167729/01a0394f-8198-755b-afa3-59ad0105e445.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Museum of Fine Arts, St. Petersburg near Vantage St. Pete Apartment",
      "link": "false",
      "alt_text": "Museum of Fine Arts, St. Petersburg near Vantage St. Pete Apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_48-1920w.jpg"
    },
    {
      "id": "ec_9c402f3fae54db411e5c2a99",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-81e6-7380-bdbf-be5dd53c1fd8.webp",
      "image_media": {
        "alt_text": "Museum of Fine Arts St. Petersburg building exterior with grand entrance and columns.",
        "public_id": "01a0394f-81e6-7380-bdbf-be5dd53c1fd8",
        "storage_key": "property/6767906449167729/01a0394f-81e6-7380-bdbf-be5dd53c1fd8.webp",
        "width": 1418,
        "height": 1016
      },
      "title": "Community",
      "description": "Museum of Fine Arts near Vantage St. Pete Apartment",
      "link": "false",
      "alt_text": "Museum of Fine Arts near Vantage St. Pete Apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_49-1920w.jpg"
    },
    {
      "id": "ec_7e0cf60b287bb0ae8e39fb94",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-8363-733c-9a57-abaafbb64298.webp",
      "image_media": {
        "alt_text": "A pedestrian walkway lined with shops and palm trees, featuring a prominent \"SUNDIAL\" sign with \"amc\" below it.",
        "public_id": "01a0394f-8363-733c-9a57-abaafbb64298",
        "storage_key": "property/6767906449167729/01a0394f-8363-733c-9a57-abaafbb64298.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "AMC near Vantage St. Pete Apartment",
      "link": "false",
      "alt_text": "AMC near Vantage St. Pete Apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_50-1920w.jpg"
    },
    {
      "id": "ec_67e085260e25d69c2ef221c4",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-847b-76bd-83a3-7f868d01cded.webp",
      "image_media": {
        "alt_text": "Modern outdoor sculpture with dolphins and a sundial in a city plaza.",
        "public_id": "01a0394f-847b-76bd-83a3-7f868d01cded",
        "storage_key": "property/6767906449167729/01a0394f-847b-76bd-83a3-7f868d01cded.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Park near Vantage St. Pete Apartment",
      "link": "false",
      "alt_text": "Park near Vantage St. Pete Apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_52-1920w.jpg"
    },
    {
      "id": "ec_229f4e83bc31dbc15673a8ce",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-86d2-737e-919b-793e0a86a4f2.webp",
      "image_media": {
        "alt_text": "Exterior view of the Flamingo, a pink building with a flamingo mural and neon sign.",
        "public_id": "01a0394f-86d2-737e-919b-793e0a86a4f2",
        "storage_key": "property/6767906449167729/01a0394f-86d2-737e-919b-793e0a86a4f2.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Entertainment near Vantage St. Pete Apartment",
      "link": "false",
      "alt_text": "Entertainment near Vantage St. Pete Apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_42-0e93aba3-1920w.jpg"
    },
    {
      "id": "ec_8d6f05a447c06346b2c2afa4",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-87ff-7770-8f8c-2f3918e620df.webp",
      "image_media": {
        "alt_text": "Exterior of a modern building with a geodesic glass dome and curved blue accents, surrounded by palm trees and greenery.",
        "public_id": "01a0394f-87ff-7770-8f8c-2f3918e620df",
        "storage_key": "property/6767906449167729/01a0394f-87ff-7770-8f8c-2f3918e620df.webp",
        "width": 1300,
        "height": 730
      },
      "title": "Community",
      "description": "Salvador Dali Museum near Vantage St. Pete",
      "link": "false",
      "alt_text": "Salvador Dali Museum near Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Drone-Vantage-3_36-1920w.jpg"
    },
    {
      "id": "ec_fee0b4223d42e1cfdb317ded",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-896d-7633-ba9b-be5e87e3c15f.webp",
      "image_media": {
        "alt_text": "Aerial view of a marina with numerous boats docked under a clear blue sky.",
        "public_id": "01a0394f-896d-7633-ba9b-be5e87e3c15f",
        "storage_key": "property/6767906449167729/01a0394f-896d-7633-ba9b-be5e87e3c15f.webp",
        "width": 1300,
        "height": 730
      },
      "title": "Community",
      "description": "Vantage St. Pete City View",
      "link": "false",
      "alt_text": "Vantage St. Pete City View",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Drone-Vantage-3_33-1920w.jpg"
    },
    {
      "id": "ec_14bcb4f31939546fc46c1736",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-8f0f-72cb-85d6-74d9785bfe66.webp",
      "image_media": {
        "alt_text": "Modern pier with palm trees and a building overlooking the ocean.",
        "public_id": "01a0394f-8f0f-72cb-85d6-74d9785bfe66",
        "storage_key": "property/6767906449167729/01a0394f-8f0f-72cb-85d6-74d9785bfe66.webp",
        "width": 1300,
        "height": 730
      },
      "title": "Community",
      "description": "St. Pete Pier",
      "link": "false",
      "alt_text": "St. Pete Pier",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Drone-Vantage-3_28-1920w.jpg"
    },
    {
      "id": "ec_eab1fedba53dce776657113a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-8f81-7699-85e7-8a65cdfb6ef4.webp",
      "image_media": {
        "alt_text": "Waterfront pier with city skyline and palm trees.",
        "public_id": "01a0394f-8f81-7699-85e7-8a65cdfb6ef4",
        "storage_key": "property/6767906449167729/01a0394f-8f81-7699-85e7-8a65cdfb6ef4.webp",
        "width": 1300,
        "height": 730
      },
      "title": "Community",
      "description": "Bridge at City St. Pete",
      "link": "false",
      "alt_text": "Bridge at City St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Drone-Vantage-3_29-1920w.jpg"
    },
    {
      "id": "ec_e32f9efa499b6761dd6d7099",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-8f81-7699-85e7-87a7a5ff6c69.webp",
      "image_media": {
        "alt_text": "Aerial view of a coastal community with tennis courts, buildings, and a beach.",
        "public_id": "01a0394f-8f81-7699-85e7-87a7a5ff6c69",
        "storage_key": "property/6767906449167729/01a0394f-8f81-7699-85e7-87a7a5ff6c69.webp",
        "width": 1300,
        "height": 730
      },
      "title": "Community",
      "description": "Seashore at St. Pete",
      "link": "false",
      "alt_text": "Seashore at St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Drone-Vantage-3_21-1920w.jpg"
    },
    {
      "id": "ec_1a01450cf5bab270a8adf844",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-8fd5-755b-b1e1-ee40cbb39b45.webp",
      "image_media": {
        "alt_text": "Aerial view of a waterfront city skyline with apartments, a bay, and a marina.",
        "public_id": "01a0394f-8fd5-755b-b1e1-ee40cbb39b45",
        "storage_key": "property/6767906449167729/01a0394f-8fd5-755b-b1e1-ee40cbb39b45.webp",
        "width": 1300,
        "height": 730
      },
      "title": "Community",
      "description": "St. Pete City View",
      "link": "false",
      "alt_text": "St. Pete City View",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Drone-Vantage-3_23-1920w.jpg"
    },
    {
      "id": "ec_d82e66596412f86d66291020",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5403-7139-aabd-95f066163216.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, including a refrigerator, microwave, and oven, as well as sleek cabinets and a large sink.",
        "public_id": "01a0394f-5403-7139-aabd-95f066163216",
        "storage_key": "property/6767906449167729/01a0394f-5403-7139-aabd-95f066163216.webp",
        "width": 1299,
        "height": 866
      },
      "title": "Apartment",
      "description": "Apartment Kitchen at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Kitchen at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_08-1920w.jpg"
    },
    {
      "id": "ec_5091909524025c0de0926cfd",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-4998-7743-8d2b-7b2b73e9ba96.webp",
      "image_media": {
        "alt_text": "Modern studio apartment with murphy bed, living area, and full kitchen.",
        "public_id": "01a0394f-4998-7743-8d2b-7b2b73e9ba96",
        "storage_key": "property/6767906449167729/01a0394f-4998-7743-8d2b-7b2b73e9ba96.webp",
        "width": 1294,
        "height": 863
      },
      "title": "Apartment",
      "description": "Open Floor Plans at Vantage St. Pete",
      "link": "false",
      "alt_text": "Open Floor Plans at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_07-1920w.jpg"
    },
    {
      "id": "ec_0eca4f5f3fbd98b2da238a11",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-54ec-73ab-ac72-e2f12fb5536c.webp",
      "image_media": {
        "alt_text": "Luxurious living room with leather couch, coffee table, and modern art.",
        "public_id": "01a0394f-54ec-73ab-ac72-e2f12fb5536c",
        "storage_key": "property/6767906449167729/01a0394f-54ec-73ab-ac72-e2f12fb5536c.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Apartment Living Room at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Living Room at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_14-1920w.jpg"
    },
    {
      "id": "ec_79a6c30770f4b1dea0071b2f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-55f1-76a0-8c8c-1e7fa5ed9816.webp",
      "image_media": {
        "alt_text": "Modern living room with a tufted leather sofa, two armchairs, and large windows.",
        "public_id": "01a0394f-55f1-76a0-8c8c-1e7fa5ed9816",
        "storage_key": "property/6767906449167729/01a0394f-55f1-76a0-8c8c-1e7fa5ed9816.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Apartment Living Room with Expansive Window Walls at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Living Room with Expansive Window Walls at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_12-1920w.jpg"
    },
    {
      "id": "ec_d0a48833169f6b645093ce2b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5654-737f-8909-80ddb9cb72d9.webp",
      "image_media": {
        "alt_text": "Murphy bed pulled down in a studio apartment with a chair and coffee table.",
        "public_id": "01a0394f-5654-737f-8909-80ddb9cb72d9",
        "storage_key": "property/6767906449167729/01a0394f-5654-737f-8909-80ddb9cb72d9.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Apartment with High End Finishes at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment with High End Finishes at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_10-1920w.jpg"
    },
    {
      "id": "ec_11e9f54b43fdedde58899803",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-9555-73ca-9d71-c6a4b1509cfe.webp",
      "image_media": {
        "alt_text": "A modern bedroom with a queen-size bed, teal headboard, and a vintage trunk at the foot of the bed.",
        "public_id": "01a0394f-9555-73ca-9d71-c6a4b1509cfe",
        "storage_key": "property/6767906449167729/01a0394f-9555-73ca-9d71-c6a4b1509cfe.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Apartment Bedroom at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Bedroom at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_15-1920w.jpg"
    },
    {
      "id": "ec_dc3a55cde5d4887302be8228",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-95af-7492-9c4e-65c3f10fdfee.webp",
      "image_media": {
        "alt_text": "Industrial-style bedroom with a metal bed frame, dark blue accent wall, and a large window.",
        "public_id": "01a0394f-95af-7492-9c4e-65c3f10fdfee",
        "storage_key": "property/6767906449167729/01a0394f-95af-7492-9c4e-65c3f10fdfee.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Apartment Bedroom with Bed at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Bedroom with Bed at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_17-1920w.jpg"
    },
    {
      "id": "ec_dab12592231ab2f0345e39e3",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-9704-71ed-89ec-af59ec2295b4.webp",
      "image_media": {
        "alt_text": "Bedroom with a tufted headboard, decorative pillows, and a large abstract painting on the wall.",
        "public_id": "01a0394f-9704-71ed-89ec-af59ec2295b4",
        "storage_key": "property/6767906449167729/01a0394f-9704-71ed-89ec-af59ec2295b4.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Bedroom at Vantage St. Pete",
      "link": "false",
      "alt_text": "Bedroom at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_16-1920w.jpg"
    },
    {
      "id": "ec_a55b1fcf3c1ae543a3bf757a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-97a4-712a-ad3f-5087f7811481.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
        "public_id": "01a0394f-97a4-712a-ad3f-5087f7811481",
        "storage_key": "property/6767906449167729/01a0394f-97a4-712a-ad3f-5087f7811481.webp",
        "width": 1334,
        "height": 889
      },
      "title": "Apartment",
      "description": "Bathroom at Vantage St. Pete",
      "link": "false",
      "alt_text": "Bathroom at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_09-1920w.jpg"
    },
    {
      "id": "ec_719e19347bc814c22912b647",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-987c-758c-9dde-5b433b242bf3.webp",
      "image_media": {
        "alt_text": "View from a balcony with a chair overlooking a city street and buildings.",
        "public_id": "01a0394f-987c-758c-9dde-5b433b242bf3",
        "storage_key": "property/6767906449167729/01a0394f-987c-758c-9dde-5b433b242bf3.webp",
        "width": 896,
        "height": 1344
      },
      "title": "Apartment",
      "description": "Apartment Balcony at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Balcony at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_11-1920w.jpg"
    },
    {
      "id": "ec_72c3328d1714ed8edfdd9bee",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-97a3-75ed-ac06-b063ec7da3a4.webp",
      "image_media": {
        "alt_text": "Balcony view of city skyline and stadium",
        "public_id": "01a0394f-97a3-75ed-ac06-b063ec7da3a4",
        "storage_key": "property/6767906449167729/01a0394f-97a3-75ed-ac06-b063ec7da3a4.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Apartment Expansive Balcony at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Expansive Balcony at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_13-1920w.jpg"
    },
    {
      "id": "ec_0e60f7c289a2f115fdb70ed3",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-9c6f-7483-b20f-e54756c4c39b.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer unit in a closet.",
        "public_id": "01a0394f-9c6f-7483-b20f-e54756c4c39b",
        "storage_key": "property/6767906449167729/01a0394f-9c6f-7483-b20f-e54756c4c39b.webp",
        "width": 1093,
        "height": 1638
      },
      "title": "Apartment",
      "description": "In Unit Washers & Dryers at Vantage St. Pete",
      "link": "false",
      "alt_text": "In Unit Washers & Dryers at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_29-1920w.jpg"
    },
    {
      "id": "ec_38b841bdd54f95faaca7e01e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-9e15-7781-8546-911c82d32c73.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances, island with bar stools, and decorative console table.",
        "public_id": "01a0394f-9e15-7781-8546-911c82d32c73",
        "storage_key": "property/6767906449167729/01a0394f-9e15-7781-8546-911c82d32c73.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Kitchen with Quartz Countertops at Vantage St. Pete",
      "link": "false",
      "alt_text": "Kitchen with Quartz Countertops at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_36-1920w.jpg"
    },
    {
      "id": "ec_117e8042aee0cb5a3aa5bcbd",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-a07b-7150-b7f4-f21753835679.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and wood-look flooring.",
        "public_id": "01a0394f-a07b-7150-b7f4-f21753835679",
        "storage_key": "property/6767906449167729/01a0394f-a07b-7150-b7f4-f21753835679.webp",
        "width": 1636,
        "height": 1091
      },
      "title": "Apartment",
      "description": "Kitchen with Stainless Steel Appliances at Vantage St. Pete",
      "link": "false",
      "alt_text": "Kitchen with Stainless Steel Appliances at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_37-1920w.jpg"
    },
    {
      "id": "ec_dae99cec315d834c70d049df",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-9fec-75e4-95d8-b3d6e313278d.webp",
      "image_media": {
        "alt_text": "Modern kitchen faucet with pull-down sprayer over stainless steel sink.",
        "public_id": "01a0394f-9fec-75e4-95d8-b3d6e313278d",
        "storage_key": "property/6767906449167729/01a0394f-9fec-75e4-95d8-b3d6e313278d.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Kitchen Sink at Vantage St. Pete",
      "link": "false",
      "alt_text": "Kitchen Sink at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_38-1920w.jpg"
    },
    {
      "id": "ec_aeba37fc0c54096a42b80b8f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-a1d9-7601-ab62-3963bb05e295.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and industrial pendant light.",
        "public_id": "01a0394f-a1d9-7601-ab62-3963bb05e295",
        "storage_key": "property/6767906449167729/01a0394f-a1d9-7601-ab62-3963bb05e295.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Apartment Decor Light at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Decor Light at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_39-1920w.jpg"
    },
    {
      "id": "ec_63fa2ccb49c43a471d81d8e8",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-a459-712d-ac8d-b182d6c8f43b.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table overlooking a city street and buildings.",
        "public_id": "01a0394f-a459-712d-ac8d-b182d6c8f43b",
        "storage_key": "property/6767906449167729/01a0394f-a459-712d-ac8d-b182d6c8f43b.webp",
        "width": 1598,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Apartment Outdoor Balcony at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Outdoor Balcony at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-2_40-1920w.jpg"
    },
    {
      "id": "ec_c59e2ea7755fe8fbbb167931",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-a612-718d-9164-2634bdd47ae8.webp",
      "image_media": {
        "alt_text": "Modern living room with a green sectional couch, coffee table, and large windows with a city view.",
        "public_id": "01a0394f-a612-718d-9164-2634bdd47ae8",
        "storage_key": "property/6767906449167729/01a0394f-a612-718d-9164-2634bdd47ae8.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Apartment with Oversized Windows and Balcony at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment with Oversized Windows and Balcony at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_09-1920w.jpg"
    },
    {
      "id": "ec_5693f8f211e0d263a8870671",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-a612-718d-9164-29e9a5c29bdb.webp",
      "image_media": {
        "alt_text": "Modern living room with open kitchen featuring stainless steel appliances and a green sectional sofa.",
        "public_id": "01a0394f-a612-718d-9164-29e9a5c29bdb",
        "storage_key": "property/6767906449167729/01a0394f-a612-718d-9164-29e9a5c29bdb.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Open Floor Plan at Vantage St. Pete",
      "link": "false",
      "alt_text": "Open Floor Plan at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_10-1920w.jpg"
    },
    {
      "id": "ec_c68d7acad2b669b53536b7a8",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-a6c8-70eb-b47b-06dfacec2538.webp",
      "image_media": {
        "alt_text": "Modern dining area with a round white table, wire chairs, and abstract art on the wall.",
        "public_id": "01a0394f-a6c8-70eb-b47b-06dfacec2538",
        "storage_key": "property/6767906449167729/01a0394f-a6c8-70eb-b47b-06dfacec2538.webp",
        "width": 1627,
        "height": 1085
      },
      "title": "Apartment",
      "description": "Apartment Dining Area at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Dining Area at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_11-1920w.jpg"
    },
    {
      "id": "ec_395d10e80091c03a1bcffd59",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-a685-72f2-81d7-cef8a9f5f3b5.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances, gray and white cabinetry, and a living area with a yellow couch.",
        "public_id": "01a0394f-a685-72f2-81d7-cef8a9f5f3b5",
        "storage_key": "property/6767906449167729/01a0394f-a685-72f2-81d7-cef8a9f5f3b5.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Apartment Open Kitchen at Vantage St. Pete",
      "link": "false",
      "alt_text": "Apartment Open Kitchen at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_12-1920w.jpg"
    },
    {
      "id": "ec_0f914e2fada9b1e917c658bd",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-ab8d-75da-b161-77595be867ff.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, grey and white cabinets, and a tile backsplash.",
        "public_id": "01a0394f-ab8d-75da-b161-77595be867ff",
        "storage_key": "property/6767906449167729/01a0394f-ab8d-75da-b161-77595be867ff.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Stainless Steel Appliances at Vantage St. Pete",
      "link": "false",
      "alt_text": "Stainless Steel Appliances at Vantage St. Pete",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_13-1920w.jpg"
    },
    {
      "id": "ec_71c63c4574115ad7797a602e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-addd-735b-95b1-88cc062ca466.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances, contemporary cabinetry, and open living area.",
        "public_id": "01a0394f-addd-735b-95b1-88cc062ca466",
        "storage_key": "property/6767906449167729/01a0394f-addd-735b-95b1-88cc062ca466.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Kitchen",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_14-1920w.jpg"
    },
    {
      "id": "ec_6fc2ebfc0d9980ff1f15631e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b070-7627-8b45-e817e6c50ca9.webp",
      "image_media": {
        "alt_text": "Modern living room with large windows overlooking a city skyline, featuring a tan armchair and a shelving unit with a TV.",
        "public_id": "01a0394f-b070-7627-8b45-e817e6c50ca9",
        "storage_key": "property/6767906449167729/01a0394f-b070-7627-8b45-e817e6c50ca9.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Oversized Windows",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Oversized Windows",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_15-1920w.jpg"
    },
    {
      "id": "ec_b4e5d673baff1ee681ae6b86",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b0bf-7383-b3a7-bc60c8c21414.webp",
      "image_media": {
        "alt_text": "A modern living room with a lime green sectional sofa, coffee table, and large windows.",
        "public_id": "01a0394f-b0bf-7383-b3a7-bc60c8c21414",
        "storage_key": "property/6767906449167729/01a0394f-b0bf-7383-b3a7-bc60c8c21414.webp",
        "width": 1611,
        "height": 1074
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment with Smarthome Technology",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment with Smarthome Technology",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_16-1920w.jpg"
    },
    {
      "id": "ec_4771a932b562814c17a930df",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b236-7642-9530-7aa387ed70ce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and sleek cabinetry.",
        "public_id": "01a0394f-b236-7642-9530-7aa387ed70ce",
        "storage_key": "property/6767906449167729/01a0394f-b236-7642-9530-7aa387ed70ce.webp",
        "width": 1093,
        "height": 1638
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Microwave and Stove",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Microwave and Stove",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_18-1920w.jpg"
    },
    {
      "id": "ec_142e7ebd4a53c819205a6c2e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b2eb-726b-a96e-562f3eb83a4f.webp",
      "image_media": {
        "alt_text": "Closet with a suit, shoes, and books",
        "public_id": "01a0394f-b2eb-726b-a96e-562f3eb83a4f",
        "storage_key": "property/6767906449167729/01a0394f-b2eb-726b-a96e-562f3eb83a4f.webp",
        "width": 1093,
        "height": 1638
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Walk-In Closet",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Walk-In Closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_20-1920w.jpg"
    },
    {
      "id": "ec_dd0421be89385ab7e6e8f6f2",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b704-76de-b892-93af1c15707d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and walk-in shower.",
        "public_id": "01a0394f-b704-76de-b892-93af1c15707d",
        "storage_key": "property/6767906449167729/01a0394f-b704-76de-b892-93af1c15707d.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Bathroom",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_21-1920w.jpg"
    },
    {
      "id": "ec_5d76fc38d6f9df79d17cfff1",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b82f-727f-822d-a75b9a0cc5bf.webp",
      "image_media": {
        "alt_text": "Bedroom with a tufted orange headboard, white bedding, and a brown bench.",
        "public_id": "01a0394f-b82f-727f-822d-a75b9a0cc5bf",
        "storage_key": "property/6767906449167729/01a0394f-b82f-727f-822d-a75b9a0cc5bf.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Bedroom",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Bedroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_22-1920w.jpg"
    },
    {
      "id": "ec_e76628e702c8cab4a7bc0874",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b8d0-72de-85ac-b2ae41160c78.webp",
      "image_media": {
        "alt_text": "Nest thermostat showing cooling at 72 degrees",
        "public_id": "01a0394f-b8d0-72de-85ac-b2ae41160c78",
        "storage_key": "property/6767906449167729/01a0394f-b8d0-72de-85ac-b2ae41160c78.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Other",
      "description": "Vantage St. Pete Apartment Smarthome Technology",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Smarthome Technology",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_25-1920w.jpg"
    },
    {
      "id": "ec_b5241c057cd11800cee112e1",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-b871-7659-bf43-775148ebee1b.webp",
      "image_media": {
        "alt_text": "Modern bathroom sink with a brushed nickel faucet and a decorative candle.",
        "public_id": "01a0394f-b871-7659-bf43-775148ebee1b",
        "storage_key": "property/6767906449167729/01a0394f-b871-7659-bf43-775148ebee1b.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Bathroom Sink",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Bathroom Sink",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_27-1920w.jpg"
    },
    {
      "id": "ec_d9619788e3e7c8828c3a7ff7",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-baef-72df-80ae-a9d2e51f479f.webp",
      "image_media": {
        "alt_text": "Hallway with mirrors, potted plant, and city view through window.",
        "public_id": "01a0394f-baef-72df-80ae-a9d2e51f479f",
        "storage_key": "property/6767906449167729/01a0394f-baef-72df-80ae-a9d2e51f479f.webp",
        "width": 1637,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Hallway",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Hallway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_28-1920w.jpg"
    },
    {
      "id": "ec_2cc8651c1628c4aa1f1e608b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-bc81-719b-bb56-78abf4008b2e.webp",
      "image_media": {
        "alt_text": "Modern studio apartment living area with murphy bed and city views.",
        "public_id": "01a0394f-bc81-719b-bb56-78abf4008b2e",
        "storage_key": "property/6767906449167729/01a0394f-bc81-719b-bb56-78abf4008b2e.webp",
        "width": 1628,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Living Room with High End Finishes",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Living Room with High End Finishes",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_29-1920w.jpg"
    },
    {
      "id": "ec_cee138c01002189c77e2df9e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-bf98-7337-935a-4dffcaa2ab8c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a dining table",
        "public_id": "01a0394f-bf98-7337-935a-4dffcaa2ab8c",
        "storage_key": "property/6767906449167729/01a0394f-bf98-7337-935a-4dffcaa2ab8c.webp",
        "width": 1611,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Kitchen",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_30-1920w.jpg"
    },
    {
      "id": "ec_30516491b3e750fb0369fc32",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-c170-7489-b296-3eb145a20205.webp",
      "image_media": {
        "alt_text": "Living room with large window overlooking city skyline and modern furniture.",
        "public_id": "01a0394f-c170-7489-b296-3eb145a20205",
        "storage_key": "property/6767906449167729/01a0394f-c170-7489-b296-3eb145a20205.webp",
        "width": 1638,
        "height": 1093
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Expansive Living Room",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Expansive Living Room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage-3_32-1920w.jpg"
    },
    {
      "id": "ec_d49ca11de7240dfb6b0c73c8",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-c206-70ad-8923-0260481b7073.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, white countertops, subway tile backsplash, and stainless steel sink.",
        "public_id": "01a0394f-c206-70ad-8923-0260481b7073",
        "storage_key": "property/6767906449167729/01a0394f-c206-70ad-8923-0260481b7073.webp",
        "width": 1344,
        "height": 896
      },
      "title": "Apartment",
      "description": "Vantage St. Pete Apartment Gourmet Kitchen with Quartz Countertops",
      "link": "false",
      "alt_text": "Vantage St. Pete Apartment Gourmet Kitchen with Quartz Countertops",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/dms3rep/multi/opt/Web-Vantage_20-1920w.jpg"
    },
    {
      "id": "ec_9b458c529c6ca080617ccc4d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-513c-709d-a3ab-de543304ccad.webp",
      "image_media": {
        "alt_text": "Multihub logo",
        "public_id": "01a0394f-513c-709d-a3ab-de543304ccad",
        "storage_key": "property/6767906449167729/01a0394f-513c-709d-a3ab-de543304ccad.webp",
        "width": 1920,
        "height": 284
      },
      "title": "Logo",
      "description": "The official logo for Multihub, featuring a colorful gradient from purple to orange.",
      "link": "false",
      "alt_text": "Multihub logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/opt/Multihub+Logo+Color+%281%29-1920w.png"
    },
    {
      "id": "ec_43fccd260659286a39922790",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-5152-721e-bc30-c9349c9eaee2.webp",
      "image_media": {
        "alt_text": "Repli logo",
        "public_id": "01a0394f-5152-721e-bc30-c9349c9eaee2",
        "storage_key": "property/6767906449167729/01a0394f-5152-721e-bc30-c9349c9eaee2.webp",
        "width": 1014,
        "height": 496
      },
      "title": "Logo",
      "description": "The Repli logo features the word 'repli' in a stylized white font on a black background. The 'i' has a gradient circle above it.",
      "link": "false",
      "alt_text": "Repli logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/opt/Repli_White-logo-gradient-dot-41918591-1920w-1920w.webp"
    },
    {
      "id": "ec_1c78eeac2ccb472bfe389c21",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-c306-71af-9f00-484bab2d3e61.webp",
      "image_media": {
        "alt_text": "Vantage logo",
        "public_id": "01a0394f-c306-71af-9f00-484bab2d3e61",
        "storage_key": "property/6767906449167729/01a0394f-c306-71af-9f00-484bab2d3e61.webp",
        "width": 220,
        "height": 82
      },
      "title": "Logo",
      "description": "The Vantage logo, featuring a stylized 'V' and the word 'VANTAGE' in white text on a black background.",
      "link": "false",
      "alt_text": "Vantage logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/opt/Top-Tips-to-Reduce-Cumulative-Layout-Shift--28CLS-29-and-Enhance-User-Experience--281-29-223w.png"
    },
    {
      "id": "ec_0f6921a60d8ec07f78bfdaf0",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-c3eb-76bd-90c2-f1ddb30d8daf.webp",
      "image_media": {
        "alt_text": "Vantage Edge District St. Pete logo.",
        "public_id": "01a0394f-c3eb-76bd-90c2-f1ddb30d8daf",
        "storage_key": "property/6767906449167729/01a0394f-c3eb-76bd-90c2-f1ddb30d8daf.webp",
        "width": 180,
        "height": 68
      },
      "title": "Logo",
      "description": "The Vantage Edge District St. Pete logo, featuring a stylized V and the property name.",
      "link": "false",
      "alt_text": "Vantage Edge District St. Pete logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com//0852a398/import/clib/vantagestpete_com/dms3rep/multi/opt/vantage-logo-white-padded-266x100-184w.png"
    },
    {
      "id": "ec_93f7907d1d5ed83447b5b789",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-c417-7751-90aa-257734aa12ff.webp",
      "image_media": {
        "alt_text": "Multihub logo with gradient colors",
        "public_id": "01a0394f-c417-7751-90aa-257734aa12ff",
        "storage_key": "property/6767906449167729/01a0394f-c417-7751-90aa-257734aa12ff.webp",
        "width": 140,
        "height": 21
      },
      "title": "Logo",
      "description": "The Multihub logo features a colorful gradient from blue and purple to red and yellow.",
      "link": "false",
      "alt_text": "Multihub logo with gradient colors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/opt/Multihub+Logo+Color+%281%29-138w.png"
    },
    {
      "id": "ec_58f177b4458f2fbf213fe6a0",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-c5d4-7298-8792-896b588e8ce3.webp",
      "image_media": {
        "alt_text": "The 'repli' logo in white text on a black background.",
        "public_id": "01a0394f-c5d4-7298-8792-896b588e8ce3",
        "storage_key": "property/6767906449167729/01a0394f-c5d4-7298-8792-896b588e8ce3.webp",
        "width": 60,
        "height": 29
      },
      "title": "Logo",
      "description": "The 'repli' logo in white text on a black background. This logo appears to be for a company or brand.",
      "link": "false",
      "alt_text": "The 'repli' logo in white text on a black background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/opt/Repli_White-logo-gradient-dot-41918591-1920w-60w.webp"
    },
    {
      "id": "ec_9c09557995015bac1c746899",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-48f0-71aa-8d94-a91bf1ff226d.webp",
      "image_media": {
        "alt_text": "Vantage logo on a black background",
        "public_id": "01a0394f-48f0-71aa-8d94-a91bf1ff226d",
        "storage_key": "property/6767906449167729/01a0394f-48f0-71aa-8d94-a91bf1ff226d.webp",
        "width": 521,
        "height": 194
      },
      "title": "Logo",
      "description": "The official logo for Vantage, featuring a stylized 'V' and the word 'VANTAGE' in white text against a black background.",
      "link": "false",
      "alt_text": "Vantage logo on a black background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/736d44f1/dms3rep/multi/Top-Tips-to-Reduce-Cumulative-Layout-Shift--28CLS-29-and-Enhance-User-Experience--281-29.png"
    },
    {
      "id": "ec_edf957f376c8fc9238529ad3",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-c875-7429-a015-637007975dce.webp",
      "image_media": {
        "alt_text": "Calendar icon",
        "public_id": "01a0394f-c875-7429-a015-637007975dce",
        "storage_key": "property/6767906449167729/01a0394f-c875-7429-a015-637007975dce.webp",
        "width": 52,
        "height": 52
      },
      "title": "Other",
      "description": "Icon representing a calendar, often used for scheduling or dates.",
      "link": "false",
      "alt_text": "Calendar icon",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp-cdn.multiscreensite.com/0852a398/import/clib/vantagestpete_com/dms3rep/multi/banner_icon1-52x52.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_01001f8b034484e5d16b8f95",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Oxbow Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1300 Hendry St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Oysters, burgers & seafood dishes, plus cocktails in a riverfront joint with a terrace & live music.",
      "poi_long_description": "Oysters, burgers & seafood dishes, plus cocktails in a riverfront joint with a terrace & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8362-7209-a7e1-94c915c238bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8362-7209-a7e1-94c915c238bb",
        "storage_key": "property/6767906449167729/01a03951-8362-7209-a7e1-94c915c238bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oxbowfortmyers.com/?utm_source=GMB&utm_medium=WebsiteClick&utm_campaign=Fort%20Myers&utm_content=7234-28",
      "poi_directions_map_url": "https://maps.google.com/?cid=15855449835306855223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxbow-bar--grill",
      "poi_latitude": "26.64677",
      "poi_longitude": "-81.8712218",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-314-3856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXRfVqqlB24gRN6t9k57fCdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_de317a1a87ff8c3a1b698674",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "The Veranda",
      "poi_type": "Restaurants",
      "poi_address": "2122 Second St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Historic setting featuring upmarket Southern cuisine, a romantic piano bar & a garden courtyard.",
      "poi_long_description": "Historic setting featuring upmarket Southern cuisine, a romantic piano bar & a garden courtyard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-7f55-712e-be1e-89341d3eec06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-7f55-712e-be1e-89341d3eec06",
        "storage_key": "property/6767906449167729/01a03951-7f55-712e-be1e-89341d3eec06.webp",
        "width": 1280,
        "height": 776
      },
      "poi_business_url": "https://verandarestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12881419513080245890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-veranda",
      "poi_latitude": "26.6417886",
      "poi_longitude": "-81.86947669999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-332-2065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSwNz-NB24gRgu7uZ8z-w7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_41e29b9941322789e33e9946",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Downtown House of Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1520 Hendry St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Laid-back neighborhood nook with a back patio, doling out casual Italian eats such as pizza & subs.",
      "poi_long_description": "Laid-back neighborhood nook with a back patio, doling out casual Italian eats such as pizza & subs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-7e77-741a-8d70-f8e5330e60b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-7e77-741a-8d70-f8e5330e60b4",
        "storage_key": "property/6767906449167729/01a03951-7e77-741a-8d70-f8e5330e60b4.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.downtownhouseofpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17082530156017065974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-house-of-pizza",
      "poi_latitude": "26.6439163",
      "poi_longitude": "-81.86963539999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-337-3467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSaQDBuNB24gR9p9LdqtWEe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_64be0ed18724b400776c8366",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "The Standard Restaurant Downtown",
      "poi_type": "Restaurants",
      "poi_address": "1520 Broadway, Fort Myers, FL 33901, USA",
      "poi_short_description": "Convivial eatery serving elevated American dishes & craft cocktails, plus trivia nights.",
      "poi_long_description": "Convivial eatery serving elevated American dishes & craft cocktails, plus trivia nights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8624-761c-b810-0468112990de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8624-761c-b810-0468112990de",
        "storage_key": "property/6767906449167729/01a03951-8624-761c-b810-0468112990de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thestandardftmyers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1009558760836889529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-standard-restaurant-downtown",
      "poi_latitude": "26.6432598",
      "poi_longitude": "-81.87062449999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-219-6463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3r4meNB24gRufuQF1isAg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_7ab6c5ad327708653e9ce083",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "City Tavern",
      "poi_type": "Restaurants",
      "poi_address": "2206 Bay St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Updated pub grub & cocktails served in a bustling setting with outdoor seats & live music events.",
      "poi_long_description": "Updated pub grub & cocktails served in a bustling setting with outdoor seats & live music events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-877d-7728-b9ce-80b89b1b183f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-877d-7728-b9ce-80b89b1b183f",
        "storage_key": "property/6767906449167729/01a03951-877d-7728-b9ce-80b89b1b183f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.mycitytavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12939352839209258662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-tavern",
      "poi_latitude": "26.6445656",
      "poi_longitude": "-81.8708587",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-226-1133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c2f4-76db-833b-20f7f6837a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c2f4-76db-833b-20f7f6837a83",
        "storage_key": "property/6767906449167729/01a03951-c2f4-76db-833b-20f7f6837a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE9wRb-NB24gRpo6CBNrQkbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_e261f6d69a53ef2db320c846",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "The Firestone Skybar & Martini Bar",
      "poi_type": "Restaurants",
      "poi_address": "2224 Bay St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Sprawling 4-story bar & grill serving steakhouse fare & cocktails in cool, industrial digs.",
      "poi_long_description": "Sprawling 4-story bar & grill serving steakhouse fare & cocktails in cool, industrial digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-7edb-7536-ba77-04a2fa530f17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-7edb-7536-ba77-04a2fa530f17",
        "storage_key": "property/6767906449167729/01a03951-7edb-7536-ba77-04a2fa530f17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.firestonefl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15046423027392439780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-firestone-skybar--martini-bar",
      "poi_latitude": "26.6447549",
      "poi_longitude": "-81.8703264",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-334-3473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_uMa-NB24gR5OX7Jwaiz9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_b9ececece40cf12a5d99e0cf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Capone's Coal Fired Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2225 First St #201, Fort Myers, FL 33901, USA",
      "poi_short_description": "Sprawling pizzeria serving coal-fired pies & other Italian fare amid Jazz Age–inspired decor.",
      "poi_long_description": "Sprawling pizzeria serving coal-fired pies & other Italian fare amid Jazz Age–inspired decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8233-749b-aadd-cf28ce791628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8233-749b-aadd-cf28ce791628",
        "storage_key": "property/6767906449167729/01a03951-8233-749b-aadd-cf28ce791628.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.caponescoalfiredpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9179301295968637926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capones-coal-fired-pizza",
      "poi_latitude": "26.6442419",
      "poi_longitude": "-81.8702931",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-337-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2woc-NB24gR5lN-COVtY38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_067424dce032403f3c3395a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Izzy's Fish & Oyster",
      "poi_type": "Restaurants",
      "poi_address": "2282 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Modern seafood eatery with a large, easygoing dining room & a sizable raw bar.",
      "poi_long_description": "Modern seafood eatery with a large, easygoing dining room & a sizable raw bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8313-7608-86c7-198f35582f54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8313-7608-86c7-198f35582f54",
        "storage_key": "property/6767906449167729/01a03951-8313-7608-86c7-198f35582f54.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://izzysftmyers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13502013431680446688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "izzys-fish--oyster",
      "poi_latitude": "26.6448191",
      "poi_longitude": "-81.86877419999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-337-4999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr4sd4uJB24gR4LDd663JYLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_902e42605e129181d0f11e2e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "3 Pepper Burrito Company",
      "poi_type": "Restaurants",
      "poi_address": "2231 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Downtown eatery featuring made-to-order burritos, bowls and tacos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-825c-730a-8c79-047da3ee2241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-825c-730a-8c79-047da3ee2241",
        "storage_key": "property/6767906449167729/01a03951-825c-730a-8c79-047da3ee2241.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://3pepperburrito.com/fort-myers-first-street/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14821971907540879596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3-pepper-burrito-company",
      "poi_latitude": "26.6443254",
      "poi_longitude": "-81.87013189999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-308-0480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62XHEuNB24gR7AjLc-s4ss0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_336bc44ac549ce5d6b8b7b97",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "10 Twenty Five",
      "poi_type": "Restaurants",
      "poi_address": "33 Patio De Leon, Fort Myers, FL 33901, USA",
      "poi_short_description": "Casual mains & craft cocktails whipped up in an easygoing locale with patio & rooftop seating.",
      "poi_long_description": "Casual mains & craft cocktails whipped up in an easygoing locale with patio & rooftop seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8cd9-71ec-9ff7-24476c8873c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8cd9-71ec-9ff7-24476c8873c6",
        "storage_key": "property/6767906449167729/01a03951-8cd9-71ec-9ff7-24476c8873c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10twentyfive.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6467286867208256912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "10-twenty-five",
      "poi_latitude": "26.6437119",
      "poi_longitude": "-81.87013379999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-208-6903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcY7qItB24gRkD1__CNrwFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0326c701604d47b8bcfa1ca4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Bay Street Yard",
      "poi_type": "Restaurants",
      "poi_address": "2136 Bay St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-85dc-771a-96c8-5d3c2bca8644.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-85dc-771a-96c8-5d3c2bca8644",
        "storage_key": "property/6767906449167729/01a03951-85dc-771a-96c8-5d3c2bca8644.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "https://baystreetyard.com/?utm_source=GMB&utm_medium=WebsiteClick&utm_campaign=Fort%20Myers&utm_content=7234-42",
      "poi_directions_map_url": "https://maps.google.com/?cid=1297929158990677284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-street-yard",
      "poi_latitude": "26.6441519",
      "poi_longitude": "-81.87125999999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c2f4-76db-833b-20f7f6837a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c2f4-76db-833b-20f7f6837a83",
        "storage_key": "property/6767906449167729/01a03951-c2f4-76db-833b-20f7f6837a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzx0LcRB24gRJMVCgbErAxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_55e8bc34f6d84658f6a04ccf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Bruno's of Brooklyn, Italian Eatery",
      "poi_type": "Restaurants",
      "poi_address": "2149 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Casual, family-operated restaurant focusing on Sicilian-inspired recipes, by way of NYC.",
      "poi_long_description": "Casual, family-operated restaurant focusing on Sicilian-inspired recipes, by way of NYC.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8939-70a8-9453-f760a606e10e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8939-70a8-9453-f760a606e10e",
        "storage_key": "property/6767906449167729/01a03951-8939-70a8-9453-f760a606e10e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.brunosofbrooklyn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12193808230745891242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brunos-of-brooklyn-italian-eatery",
      "poi_latitude": "26.6440121",
      "poi_longitude": "-81.8707036",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-278-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxH1xuNB24gRquHX9PobOak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_e90adffb339a10d7bf6c79e2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Mason's Famous Lobster Rolls",
      "poi_type": "Restaurants",
      "poi_address": "2122 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Casual eatery for lobster rolls in classic and Connecticut versions, plus clam chowder.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8a66-7264-8cef-220de33beec8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8a66-7264-8cef-220de33beec8",
        "storage_key": "property/6767906449167729/01a03951-8a66-7264-8cef-220de33beec8.webp",
        "width": 1280,
        "height": 785
      },
      "poi_business_url": "https://www.masonslobster.com/locations/fort-myers-fl/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15787595941244336597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "masons-famous-lobster-rolls",
      "poi_latitude": "26.643641",
      "poi_longitude": "-81.87089900000001",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-208-7271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f6-70af-852d-4101efe7cfdf",
        "storage_key": "property/6767906449167729/01a0394e-c9f6-70af-852d-4101efe7cfdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRpf16VB24gR1XlEv9zOGNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_39199624199a962d9be7c7f4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Peter's German Café",
      "poi_type": "Restaurants",
      "poi_address": "1412 Dean St #100, Fort Myers, FL 33901, USA",
      "poi_short_description": "European cafe featuring a menu of cake, coffee & handmade ice cream in a cozy space.",
      "poi_long_description": "European cafe featuring a menu of cake, coffee & handmade ice cream in a cozy space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8c02-7428-bc3c-78422b7d944d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8c02-7428-bc3c-78422b7d944d",
        "storage_key": "property/6767906449167729/01a03951-8c02-7428-bc3c-78422b7d944d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.peterscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4808062273994654386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peters-german-caf",
      "poi_latitude": "26.6443291",
      "poi_longitude": "-81.8709488",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-400-5282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c2f3-77b2-aab1-dc06db7e455e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c2f3-77b2-aab1-dc06db7e455e",
        "storage_key": "property/6767906449167729/01a03951-c2f3-77b2-aab1-dc06db7e455e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJl3qeVOJB24gRsoJo-ymruUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_6dbad11157b2c6deb1b91fe3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "bullig",
      "poi_type": "Restaurants",
      "poi_address": "1815/1 Fowler St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Laid-back hangout serving breakfast classics including waffles (sweet and savory).",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-91d1-7459-9837-9a3c2e454920.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-91d1-7459-9837-9a3c2e454920",
        "storage_key": "property/6767906449167729/01a03951-91d1-7459-9837-9a3c2e454920.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1117365743390960286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bullig",
      "poi_latitude": "26.6428586",
      "poi_longitude": "-81.8632212",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 239-738-8582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c2f3-77b2-aab1-dc06db7e455e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c2f3-77b2-aab1-dc06db7e455e",
        "storage_key": "property/6767906449167729/01a03951-c2f3-77b2-aab1-dc06db7e455e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJhRIWWahr24gRnioCOzmugQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_01ba262351f31d00b63ffd15",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Centennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2000 W First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Public park along the Caloosahatchee River, with footpaths, public art, a pier & covered pavilions.",
      "poi_long_description": "Public park along the Caloosahatchee River, with footpaths, public art, a pier & covered pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-b7e1-778d-ad34-c1f7f81414ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-b7e1-778d-ad34-c1f7f81414ca",
        "storage_key": "property/6767906449167729/01a0394e-b7e1-778d-ad34-c1f7f81414ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortmyers.gov/facilities/facility/details/Centennial-Park-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=15151807918334069750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-park",
      "poi_latitude": "26.6437185",
      "poi_longitude": "-81.8740711",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-321-7524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQ_rTeRB24gR9stAJQYJRtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d796c4b84a1f1b8b32495af8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Publix Super Market at First Street Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2160 McGregor Blvd, Fort Myers, FL 33901, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-908c-7285-b179-81a11ff148a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-908c-7285-b179-81a11ff148a2",
        "storage_key": "property/6767906449167729/01a03951-908c-7285-b179-81a11ff148a2.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1156&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=1053224894560178212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-first-street-village",
      "poi_latitude": "26.6378425",
      "poi_longitude": "-81.8766783",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 239-332-2403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca0a-76de-bbca-d3cfdf242838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca0a-76de-bbca-d3cfdf242838",
        "storage_key": "property/6767906449167729/01a0394e-ca0a-76de-bbca-d3cfdf242838.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJeKL0OdB24gRJJDbHHbOnQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_faaeb12b828648e36f98a218",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "2403 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-8fe7-71d4-8bc2-da669f074e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-8fe7-71d4-8bc2-da669f074e89",
        "storage_key": "property/6767906449167729/01a03951-8fe7-71d4-8bc2-da669f074e89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/fort-myers-fl-pharmacies/2403-cleveland-ave-fort-myers-fl-33901/storeid=3941?WT.mc_id=LS_GOOGLE_FS_3941",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805735579662474714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "26.633013",
      "poi_longitude": "-81.87174809999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-332-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSm92N1B24gR2t1ceakct7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_3ceddd670ffeb8e4c27f7ce2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Save A Lot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3257 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "Discount supermarket chain carrying brand-name & private-label grocery items.",
      "poi_long_description": "Discount supermarket chain carrying brand-name & private-label grocery items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-90b0-751b-bf98-996d2438e397.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-90b0-751b-bf98-996d2438e397",
        "storage_key": "property/6767906449167729/01a03951-90b0-751b-bf98-996d2438e397.webp",
        "width": 1179,
        "height": 855
      },
      "poi_business_url": "https://savealot.com/stores/21351?utm_campaign=gmb&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12243451400825332444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "save-a-lot",
      "poi_latitude": "26.617958",
      "poi_longitude": "-81.8704965",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 239-939-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca0a-76de-bbca-d3cfdf242838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca0a-76de-bbca-d3cfdf242838",
        "storage_key": "property/6767906449167729/01a0394e-ca0a-76de-bbca-d3cfdf242838.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZbLUdFB24gR3OLzMi566ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d4f32015d818b6d0ffa57c1c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "K & M Food Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "2441 Hanson St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2287070242050689602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k--m-food-store",
      "poi_latitude": "26.6228447",
      "poi_longitude": "-81.86280099999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 239-334-7699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca0a-76de-bbca-d3cfdf242838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca0a-76de-bbca-d3cfdf242838",
        "storage_key": "property/6767906449167729/01a0394e-ca0a-76de-bbca-d3cfdf242838.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ9X8fXdq24gRQkrMiUROvR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_945249a91c94e3cbf350671a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "blue Goodwill Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "2285 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-90b1-7377-ba4e-bf948b292a09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-90b1-7377-ba4e-bf948b292a09",
        "storage_key": "property/6767906449167729/01a03951-90b1-7377-ba4e-bf948b292a09.webp",
        "width": 480,
        "height": 480
      },
      "poi_business_url": "http://www.goodwillswfl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5328572159591856785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-goodwill-boutique",
      "poi_latitude": "26.6449969",
      "poi_longitude": "-81.8688774",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-332-2026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1842344b69a2",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZYKzx-JB24gRkTqCrCXk8kk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "ec_d55c3aeee8102b61270d970a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Enjewel",
      "poi_type": "Shopping & Retail",
      "poi_address": "2266 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Boutique offering clothes, jewelry and gifts, plus friendly service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9307-739a-af65-d48246dc8935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9307-739a-af65-d48246dc8935",
        "storage_key": "property/6767906449167729/01a03951-9307-739a-af65-d48246dc8935.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://enjewel-ftmyers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4389248882991316648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enjewel",
      "poi_latitude": "26.64456",
      "poi_longitude": "-81.86921439999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-332-0293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1842344b69a2",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqVjdDONB24gRqD56lZq-6Tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_8bd260c405be088f75d59bbb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Savvy On First",
      "poi_type": "Shopping & Retail",
      "poi_address": "2263 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9523-76a3-ab05-167fcb3c1b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9523-76a3-ab05-167fcb3c1b3e",
        "storage_key": "property/6767906449167729/01a03951-9523-76a3-ab05-167fcb3c1b3e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4906927795892359224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savvy-on-first",
      "poi_latitude": "26.6448053",
      "poi_longitude": "-81.8695023",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-265-1591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1842344b69a2",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ33kXT-hB24gROJCnFNXoGEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "ec_7b778107f98e9d4599d4e5ca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Eyeing the Past",
      "poi_type": "Shopping & Retail",
      "poi_address": "1936 Commercial Dr, Fort Myers, FL 33901, USA",
      "poi_short_description": "Large shop, featuring booths with eclectic items sold by vendors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-95f2-716b-9339-4f3a59fbe7c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-95f2-716b-9339-4f3a59fbe7c1",
        "storage_key": "property/6767906449167729/01a03951-95f2-716b-9339-4f3a59fbe7c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.eyeingthepast.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3125012865766182871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eyeing-the-past",
      "poi_latitude": "26.6029308",
      "poi_longitude": "-81.8729719",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 239-275-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1842344b69a2",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZVr4Hy9A24gR18-E9qRGXis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "ec_34a7d39fd432995443ebc36a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Edison Park Creative and Expressive Arts School",
      "poi_type": "Education",
      "poi_address": "2401 Euclid Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://epe.leeschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7564809052352353435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edison-park-creative-and-expressive-arts-school",
      "poi_latitude": "26.6329057",
      "poi_longitude": "-81.8748116",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 239-334-6232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz1zADd1B24gRmxQfx8CZ-2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_bbef6b95e372072459ee8074",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Fort Myers High School",
      "poi_type": "Education",
      "poi_address": "2635 Cortez Blvd, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-94b1-71d2-a9a5-4552c24ca7c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-94b1-71d2-a9a5-4552c24ca7c8",
        "storage_key": "property/6767906449167729/01a03951-94b1-71d2-a9a5-4552c24ca7c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fmh.leeschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14368679476606235756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-myers-high-school",
      "poi_latitude": "26.6282483",
      "poi_longitude": "-81.8776644",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 239-334-2167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTVLpyMRB24gRbHSP_trNZ8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_71717e722032feca83f25457",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Fort Myers Middle School",
      "poi_type": "Education",
      "poi_address": "3050 Central Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-96b7-7189-8cd6-5e7344d18e99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-96b7-7189-8cd6-5e7344d18e99",
        "storage_key": "property/6767906449167729/01a03951-96b7-7189-8cd6-5e7344d18e99.webp",
        "width": 960,
        "height": 375
      },
      "poi_business_url": "http://fmm.leeschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17645661125344103625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-myers-middle-school",
      "poi_latitude": "26.6197533",
      "poi_longitude": "-81.8650653",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 239-936-1759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQbDFaHhq24gRyQwOg0374fQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8ccb1c2e4c30ddfe2d38572e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "St. Francis Xavier Catholic School",
      "poi_type": "Education",
      "poi_address": "2055 Heitman St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9775-74dc-a7e2-586c43203c02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9775-74dc-a7e2-586c43203c02",
        "storage_key": "property/6767906449167729/01a03951-9775-74dc-a7e2-586c43203c02.webp",
        "width": 615,
        "height": 377
      },
      "poi_business_url": "https://stfrancisfortmyers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12063451028711234379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-francis-xavier-catholic-school",
      "poi_latitude": "26.6386494",
      "poi_longitude": "-81.8706505",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-334-7707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfyNyMuFB24gRS1uns8v8aac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a404d02d685c211aa970f0b4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Saint Michael Lutheran Church & School",
      "poi_type": "Education",
      "poi_address": "3595 Broadway, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-98f0-766a-af04-1798a8bbbc03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-98f0-766a-af04-1798a8bbbc03",
        "storage_key": "property/6767906449167729/01a03951-98f0-766a-af04-1798a8bbbc03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.smlcs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12853268254129047515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-michael-lutheran-church--school",
      "poi_latitude": "26.6107545",
      "poi_longitude": "-81.8667698",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 239-939-1218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4xE-typA24gR28cqqmD7X7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_5f0bbb4687929db0c58e97aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Allen Park Elementary School",
      "poi_type": "Education",
      "poi_address": "3345 Canelo Dr, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9aab-715f-b5b7-1aa036af155d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9aab-715f-b5b7-1aa036af155d",
        "storage_key": "property/6767906449167729/01a03951-9aab-715f-b5b7-1aa036af155d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://alp.leeschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5840839115961238886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allen-park-elementary-school",
      "poi_latitude": "26.6169747",
      "poi_longitude": "-81.8767506",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 239-936-1459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb-c3DtJB24gRZoUT2TrUDlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_aa880482ae4a75a2033dee45",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Grace Community School",
      "poi_type": "Education",
      "poi_address": "1688 Medical Ln, Fort Myers, FL 33907, USA",
      "poi_short_description": "School, featuring flexible hours and a phonics-centered reading curriculum, where kids from 8 weeks old and up engage in dance, karate, and art activities, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9815-773a-ad7e-a795bb8db266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9815-773a-ad7e-a795bb8db266",
        "storage_key": "property/6767906449167729/01a03951-9815-773a-ad7e-a795bb8db266.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gracecommunityschools.com/locations/fort-myers",
      "poi_directions_map_url": "https://maps.google.com/?cid=8846461070963441261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grace-community-school",
      "poi_latitude": "26.5953072",
      "poi_longitude": "-81.8779733",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 239-334-3325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1VR7RztA24gRbf4YNnnxxHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_0bc4aed53b257f6e33cd3f48",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "The Children's Learning Center",
      "poi_type": "Education",
      "poi_address": "37 Barkley Cir, Fort Myers, FL 33907, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-988c-708f-87e5-8657690380ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-988c-708f-87e5-8657690380ca",
        "storage_key": "property/6767906449167729/01a03951-988c-708f-87e5-8657690380ca.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.ccswfl.org/learning-centers/-childrens-learning-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12929792551174278825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-learning-center",
      "poi_latitude": "26.5874384",
      "poi_longitude": "-81.8817973",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 239-267-1136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTfapQ5M_24gRqQ48ANLZb7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_05ae0ac78865833650dd6674",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Florida SouthWestern State College",
      "poi_type": "Education",
      "poi_address": "8099 College Pkwy, Fort Myers, FL 33919, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9d89-73bc-83d5-f47c4c80c189.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9d89-73bc-83d5-f47c4c80c189",
        "storage_key": "property/6767906449167729/01a03951-9d89-73bc-83d5-f47c4c80c189.webp",
        "width": 1280,
        "height": 995
      },
      "poi_business_url": "http://www.fsw.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12855465048036744478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-southwestern-state-college",
      "poi_latitude": "26.5517447",
      "poi_longitude": "-81.88927319999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 239-489-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRb4A1-w_24gRHh2umlnJZ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_b6e280f9c901edd2e7b3b8f2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Fort Myers Christian School",
      "poi_type": "Education",
      "poi_address": "1550 Colonial Blvd, Fort Myers, FL 33907, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9bcd-76b9-a278-5955a6e7f500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9bcd-76b9-a278-5955a6e7f500",
        "storage_key": "property/6767906449167729/01a03951-9bcd-76b9-a278-5955a6e7f500.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortmyerschristianschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13800733887160987608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-myers-christian-school",
      "poi_latitude": "26.5964019",
      "poi_longitude": "-81.8825525",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 239-939-4642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQackOCRA24gR2C_t11kOhr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_350d1ebac76879e4db5fe0c3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Edison & Ford Winter Estates",
      "poi_type": "Entertainment",
      "poi_address": "2350 McGregor Blvd, Fort Myers, FL 33901, USA",
      "poi_short_description": "21 acres featuring the former homes of Edison & Ford, a research lab, botanical gardens & a museum.",
      "poi_long_description": "21 acres featuring the former homes of Edison & Ford, a research lab, botanical gardens & a museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c179-7669-9d88-23ab71e88322.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-c179-7669-9d88-23ab71e88322",
        "storage_key": "property/6767906449167729/01a0394e-c179-7669-9d88-23ab71e88322.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edisonfordwinterestates.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14987221255200150947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edison--ford-winter-estates",
      "poi_latitude": "26.6342787",
      "poi_longitude": "-81.87951199999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 239-334-7419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca08-773f-b43e-0e7259f78523.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca08-773f-b43e-0e7259f78523",
        "storage_key": "property/6767906449167729/01a0394e-ca08-773f-b43e-0e7259f78523.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVUNg8JB24gRo5VjblNO_c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_5dbd2dea79bb3e75739fce74",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Florida Repertory Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2268 Bay St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Storied 1917 venue for plays, musicals & more produced by a regional professional theater company.",
      "poi_long_description": "Storied 1917 venue for plays, musicals & more produced by a regional professional theater company.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a197-7298-9e9f-d30fea48743b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a197-7298-9e9f-d30fea48743b",
        "storage_key": "property/6767906449167729/01a03951-a197-7298-9e9f-d30fea48743b.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.floridarep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17250266857989907581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-repertory-theatre",
      "poi_latitude": "26.6451344",
      "poi_longitude": "-81.869542",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-332-4488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2F64OJB24gRfaQuv09CZe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_fee021af776ea2fb840ef917",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Sidney & Berne Davis Art Center",
      "poi_type": "Entertainment",
      "poi_address": "2301 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9e56-7674-ab01-2f296558717f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9e56-7674-ab01-2f296558717f",
        "storage_key": "property/6767906449167729/01a03951-9e56-7674-ab01-2f296558717f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sbdac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7311014948639711833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sidney--berne-davis-art-center",
      "poi_latitude": "26.6453068",
      "poi_longitude": "-81.8684894",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-333-1933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ41tW2eJB24gRWaI9QVzxdWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_b4cf60ba25cddc209b76e65b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "IMAG History & Science Center",
      "poi_type": "Entertainment",
      "poi_address": "2000 Cranford Ave, Fort Myers, FL 33916, USA",
      "poi_short_description": "Interactive educational museum for all ages offers 60+ exhibits including a hurricane simulator.",
      "poi_long_description": "Interactive educational museum for all ages offers 60+ exhibits including a hurricane simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-a9cd-708a-b1d6-f2c5eba4a1c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-a9cd-708a-b1d6-f2c5eba4a1c7",
        "storage_key": "property/6767906449167729/01a0394e-a9cd-708a-b1d6-f2c5eba4a1c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theimag.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10013761856917289129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imag-history--science-center",
      "poi_latitude": "26.6403415",
      "poi_longitude": "-81.8591221",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 239-243-0043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca08-773f-b43e-0e7259f78523.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca08-773f-b43e-0e7259f78523",
        "storage_key": "property/6767906449167729/01a0394e-ca08-773f-b43e-0e7259f78523.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJicuoGAxq24gRqTjpiloH-Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_54e16dea9db8bf97513d992b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Burroughs Home and Gardens",
      "poi_type": "Entertainment",
      "poi_address": "2505 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Stately home with Georgian revival architecture, offering guided tours & event rentals.",
      "poi_long_description": "Stately home with Georgian revival architecture, offering guided tours & event rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ab38-74fd-a58a-6fdd16643e33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-ab38-74fd-a58a-6fdd16643e33",
        "storage_key": "property/6767906449167729/01a0394e-ab38-74fd-a58a-6fdd16643e33.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://burroughshome.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12548137585943696510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burroughs-home-and-gardens",
      "poi_latitude": "26.6469699",
      "poi_longitude": "-81.86588870000001",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 239-337-9505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca08-773f-b43e-0e7259f78523.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca08-773f-b43e-0e7259f78523",
        "storage_key": "property/6767906449167729/01a0394e-ca08-773f-b43e-0e7259f78523.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96iz9wdq24gRftTmyqbwI64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_97f9435198726c931b1563a8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Calusa Nature Center & Planetarium",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3450 Ortiz Ave, Fort Myers, FL 33905, USA",
      "poi_short_description": "This 105-acre sanctuary features nature trails, a natural history museum & planetarium exhibits.",
      "poi_long_description": "This 105-acre sanctuary features nature trails, a natural history museum & planetarium exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-be67-735b-8297-d1679a08e146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-be67-735b-8297-d1679a08e146",
        "storage_key": "property/6767906449167729/01a0394e-be67-735b-8297-d1679a08e146.webp",
        "width": 1280,
        "height": 897
      },
      "poi_business_url": "http://www.calusanature.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17957732074053457904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "calusa-nature-center--planetarium",
      "poi_latitude": "26.6156711",
      "poi_longitude": "-81.81246949999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 239-275-3435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJocBMRq9r24gR8FeYXS2uNvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_c280f6876b69dc53136ab0de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Fort Myers Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "12811 Commerce Lakes Dr #28, Fort Myers, FL 33913, USA",
      "poi_short_description": "Local beer maker featuring guided tours, plus a tasting room with outdoor seating & food trucks.",
      "poi_long_description": "Local beer maker featuring guided tours, plus a tasting room with outdoor seating & food trucks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a31c-7142-a5b4-5cd90c7cc396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a31c-7142-a5b4-5cd90c7cc396",
        "storage_key": "property/6767906449167729/01a03951-a31c-7142-a5b4-5cd90c7cc396.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fmbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7400261232516446186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-myers-brewing-company",
      "poi_latitude": "26.5617666",
      "poi_longitude": "-81.7429373",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 239-313-6576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwtPRNls24gR6rc8-WECs2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_641c46ae91d04abb97df50de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Barbara B. Mann Performing Arts Hall at FSW",
      "poi_type": "Entertainment",
      "poi_address": "13350 FSW Pkwy, Fort Myers, FL 33919, USA",
      "poi_short_description": "Musicals, symphonies & other events are featured at this Florida SouthWestern State College performing arts hall.",
      "poi_long_description": "Musicals, symphonies & other events are featured at this Florida SouthWestern State College performing arts hall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-9fdc-765d-8aaa-a8e5c3057018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-9fdc-765d-8aaa-a8e5c3057018",
        "storage_key": "property/6767906449167729/01a03951-9fdc-765d-8aaa-a8e5c3057018.webp",
        "width": 1280,
        "height": 559
      },
      "poi_business_url": "https://www.bbmannpah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10104884286577027721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barbara-b-mann-performing-arts-hall-at-fsw",
      "poi_latitude": "26.5513896",
      "poi_longitude": "-81.88734749999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 239-481-4849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYKYKO0_24gRiarZfbjCO4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_e56d800886a57450e1acbad3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Broadway Palm Dinner Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1380 Colonial Blvd, Fort Myers, FL 33907, USA",
      "poi_short_description": "Long-running theater offering a full lunch & dinner menu paired with a Broadway-style show.",
      "poi_long_description": "Long-running theater offering a full lunch & dinner menu paired with a Broadway-style show.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a0fc-766c-b16b-54ec6820fd77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a0fc-766c-b16b-54ec6820fd77",
        "storage_key": "property/6767906449167729/01a03951-a0fc-766c-b16b-54ec6820fd77.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.broadwaypalm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=646413856369944534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadway-palm-dinner-theatre",
      "poi_latitude": "26.595468",
      "poi_longitude": "-81.88789799999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 239-278-4422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZo0qDhA24gR1ifSPvqF-Ag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_afed4ae767632dc9ef43809d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Gulf Coast Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "13681 Doctors Way, Fort Myers, FL 33912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a1ea-728f-ada0-9c18c8372296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a1ea-728f-ada0-9c18c8372296",
        "storage_key": "property/6767906449167729/01a03951-a1ea-728f-ada0-9c18c8372296.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.leehealth.org/locations/find-a-location/gulf-coast-medical-center?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16493550440344398443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-coast-medical-center",
      "poi_latitude": "26.5441124",
      "poi_longitude": "-81.85004789999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 239-343-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1f1202518170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1f1202518170",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1f1202518170.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9Aos0MV24gRayq3Kb3c5OQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_54b6575375c85ffaefc2c706",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4429 Cleveland Ave #110, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a1da-74fa-875a-44b0b84dd4e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a1da-74fa-875a-44b0b84dd4e5",
        "storage_key": "property/6767906449167729/01a03951-a1da-74fa-875a-44b0b84dd4e5.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://www.concentra.com/urgent-care-centers/florida/ft-lauderdale/fort-myers-north-urgent-care/#nearbylocations_g=26.5984271254%7C-81.869869&nearbylocations_o=DistanceMi%2CAscending&nearbylocations_distancemi=20&nearbylocations_DistanceMi=20",
      "poi_directions_map_url": "https://maps.google.com/?cid=15182483762108170018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "26.5983987",
      "poi_longitude": "-81.8697353",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 239-387-0190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZ8jW7hB24gRIv-XmIoEs9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f24342606e2647e78a2de0ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "My Medical",
      "poi_type": "Health and Wellness",
      "poi_address": "3594 Broadway, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mymedicalmyclinic.com/contact-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13253078443135031085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-medical",
      "poi_latitude": "26.61128",
      "poi_longitude": "-81.86791529999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 877-203-4024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSq3zCpA24gRLVdzT6Bk7Lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_191c9f7b2845d77f3637cd13",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "AHF Pharmacy - Fort Myers",
      "poi_type": "Health and Wellness",
      "poi_address": "2320 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a458-75ad-b20b-1cd3785ae44c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a458-75ad-b20b-1cd3785ae44c",
        "storage_key": "property/6767906449167729/01a03951-a458-75ad-b20b-1cd3785ae44c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://ahfpharmacy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13320448931899265879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahf-pharmacy---fort-myers",
      "poi_latitude": "26.6339344",
      "poi_longitude": "-81.8729671",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 239-210-9985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c329-7350-8e98-17283da81480.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c329-7350-8e98-17283da81480",
        "storage_key": "property/6767906449167729/01a03951-c329-7350-8e98-17283da81480.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoy4J_hhB24gRV1OWkrq927g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_fda621446cbfbb70a9f81449",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3593 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a572-720d-a9b6-2d6db602ddfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a572-720d-a9b6-2d6db602ddfd",
        "storage_key": "property/6767906449167729/01a03951-a572-720d-a9b6-2d6db602ddfd.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3593+cleveland+ave-fort+myers-fl-33901/id=2941",
      "poi_directions_map_url": "https://maps.google.com/?cid=13635935481834992817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "26.6112416",
      "poi_longitude": "-81.8712679",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 239-936-4741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c329-7350-8e98-17283da81480.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c329-7350-8e98-17283da81480",
        "storage_key": "property/6767906449167729/01a03951-c329-7350-8e98-17283da81480.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZJ1VCtA24gRsXTrDhOTPL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_cd157b59193a23095246e536",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3853 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ac18-723e-a29d-71139ad611a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-ac18-723e-a29d-71139ad611a1",
        "storage_key": "property/6767906449167729/01a0394e-ac18-723e-a29d-71139ad611a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/fort-myers-cleveland-ave-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8164075189609779724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "26.6057719",
      "poi_longitude": "-81.8704794",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 239-267-5391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxZZXXilA24gRDFJFPCGfTHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_982fbc035b10a38d7cf685c2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Fuego Pilates-Downtown Fort Myers",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 Jackson St #100, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a916-748c-bfdc-905fa4006f6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a916-748c-bfdc-905fa4006f6d",
        "storage_key": "property/6767906449167729/01a03951-a916-748c-bfdc-905fa4006f6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fuego-pilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1712276847028928145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuego-pilates-downtown-fort-myers",
      "poi_latitude": "26.6446208",
      "poi_longitude": "-81.8688324",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-609-2397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJter_WY1B24gRkf5IaLg6wxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2ec71887c57abc9cd8f64028",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Chamuel Yoga and Crystals",
      "poi_type": "Health and Wellness",
      "poi_address": "2267 First St #13, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a75d-7390-846b-fe7cf9714f56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a75d-7390-846b-fe7cf9714f56",
        "storage_key": "property/6767906449167729/01a03951-a75d-7390-846b-fe7cf9714f56.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.chamuelyogaandcrystals.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=982738108697725492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chamuel-yoga-and-crystals",
      "poi_latitude": "26.6448484",
      "poi_longitude": "-81.86947889999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-237-2177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN3oZB_9B24gRNMoqZBpjow0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_c89b2efcd728aaf25a3304d4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Fort Myers Skatium",
      "poi_type": "Entertainment",
      "poi_address": "2250 Broadway, Fort Myers, FL 33901, USA",
      "poi_short_description": "Arena featuring an arcade, fitness center & soccer games as well as ice rink for skating & hockey.",
      "poi_long_description": "Arena featuring an arcade, fitness center & soccer games as well as ice rink for skating & hockey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-a6cf-776f-bfcf-d60f8865a59e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-a6cf-776f-bfcf-d60f8865a59e",
        "storage_key": "property/6767906449167729/01a03951-a6cf-776f-bfcf-d60f8865a59e.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "https://fortmyers.gov/skatium",
      "poi_directions_map_url": "https://maps.google.com/?cid=14757975870492974784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-myers-skatium",
      "poi_latitude": "26.6354486",
      "poi_longitude": "-81.8690237",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-321-7509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dTTjuBB24gRwB6F9Nzczsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_skating_rink"
    },
    {
      "id": "ec_6662f10339c26ad146f9b3d4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Carson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2001 W First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-ace6-74ef-b9ed-8bceab6b7809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-ace6-74ef-b9ed-8bceab6b7809",
        "storage_key": "property/6767906449167729/01a03951-ace6-74ef-b9ed-8bceab6b7809.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityftmyers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14385409966604685086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carson-park",
      "poi_latitude": "26.642169",
      "poi_longitude": "-81.8731419",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 239-321-7530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYmbPuRB24gRHg_WvyU-o8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a615f53c0fe18e3348b8aa6c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Riverwalk Apartment Homes",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2515 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-aaf9-732f-9f2e-5e6ac2903645.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-aaf9-732f-9f2e-5e6ac2903645",
        "storage_key": "property/6767906449167729/01a03951-aaf9-732f-9f2e-5e6ac2903645.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pedcorliving.com/apartments/riverwalk",
      "poi_directions_map_url": "https://maps.google.com/?cid=18050200063568502533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverwalk-apartment-homes",
      "poi_latitude": "26.6474077",
      "poi_longitude": "-81.8653868",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 239-226-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7WGg6Nr24gRBd-74VIxf_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_f9ad31b37e89e41b20b9acb2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Six Mile Cypress Slough Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7751 Penzance Blvd, Fort Myers, FL 33966, USA",
      "poi_short_description": "3,500-acre park offering wildlife, a butterfly garden & boardwalk trails through the wetlands.",
      "poi_long_description": "3,500-acre park offering wildlife, a butterfly garden & boardwalk trails through the wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-b73e-70a6-a3e4-2062c9da9afa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-b73e-70a6-a3e4-2062c9da9afa",
        "storage_key": "property/6767906449167729/01a0394e-b73e-70a6-a3e4-2062c9da9afa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sloughpreserve.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15531174903539345209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-mile-cypress-slough-preserve",
      "poi_latitude": "26.5705414",
      "poi_longitude": "-81.82656349999999",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 239-533-7550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIX7z4dZq24gROafsfUnRidc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_badf7443292144c7e68c5d36",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Lakes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7330 Gladiolus Dr, Fort Myers, FL 33908, USA",
      "poi_short_description": "Park with a freshwater lake for fishing, also offers bike & boat rentals, trails & picnic spots.",
      "poi_long_description": "Park with a freshwater lake for fishing, also offers bike & boat rentals, trails & picnic spots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-aa2c-73e8-b982-f88dce5290fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-aa2c-73e8-b982-f88dce5290fa",
        "storage_key": "property/6767906449167729/01a03951-aa2c-73e8-b982-f88dce5290fa.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.leegov.com/parks/parks/lakespark",
      "poi_directions_map_url": "https://maps.google.com/?cid=3235294836349120299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakes-park",
      "poi_latitude": "26.528064",
      "poi_longitude": "-81.876818",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 239-533-7578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTdu29E_24gRK68-KIMT5iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f01133e1643bc6f3f4d9e91a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Manatee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10901 Palm Beach Blvd, Fort Myers, FL 33905, USA",
      "poi_short_description": "Waterfront park providing trails, up-close views of manatees, an amphitheater & kayak rentals.",
      "poi_long_description": "Waterfront park providing trails, up-close views of manatees, an amphitheater & kayak rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-aaf5-7708-a24a-3f69ac8d70b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-aaf5-7708-a24a-3f69ac8d70b7",
        "storage_key": "property/6767906449167729/01a03951-aaf5-7708-a24a-3f69ac8d70b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leegov.com/parks/parks/manateepark",
      "poi_directions_map_url": "https://maps.google.com/?cid=741730690981605775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manatee-park",
      "poi_latitude": "26.6931532",
      "poi_longitude": "-81.7775541",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 239-533-7521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1kHd4Vp24gRj7H2MiIoSwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fb35c5dfdef36ae68550cec9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Lions Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2550 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "Park with a playground, pavilions, tennis, baseball & basketball courts as well as a soccer field.",
      "poi_long_description": "Park with a playground, pavilions, tennis, baseball & basketball courts as well as a soccer field.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-ae62-765f-9263-616178a62b85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-ae62-765f-9263-616178a62b85",
        "storage_key": "property/6767906449167729/01a03951-ae62-765f-9263-616178a62b85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fortmyers.gov/Facilities/Facility/Details/Lions-Park-25",
      "poi_directions_map_url": "https://maps.google.com/?cid=3067786964307606586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lions-park",
      "poi_latitude": "26.6315379",
      "poi_longitude": "-81.8728005",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-931-7027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXb_N9xB24gROvwgfv33kio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_15a199f20317c6455aa42022",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Wes Nott Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2610 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b0bc-71d9-961e-68f719dede95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b0bc-71d9-961e-68f719dede95",
        "storage_key": "property/6767906449167729/01a03951-b0bc-71d9-961e-68f719dede95.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityftmyers.com/Facilities/Facility/Details/Wes-Nott-Park-41",
      "poi_directions_map_url": "https://maps.google.com/?cid=11848494583447201911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wes-nott-park",
      "poi_latitude": "26.6282446",
      "poi_longitude": "-81.8728005",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-321-7530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca31-74fb-beeb-2657132dff42",
        "storage_key": "property/6767906449167729/01a0394e-ca31-74fb-beeb-2657132dff42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0Sl7dtB24gRd6iCMQxPbqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3539ee6c0ab837f98334d9d8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "ROSA PARKS TRANSPORTATION CTR",
      "poi_type": "Transportation & Transit",
      "poi_address": "2250 Widman Way, Fort Myers, FL 33919, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b18f-755a-b602-5f90ca78a310.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b18f-755a-b602-5f90ca78a310",
        "storage_key": "property/6767906449167729/01a03951-b18f-755a-b602-5f90ca78a310.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10933547657631072178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosa-parks-transportation-ctr",
      "poi_latitude": "26.639319",
      "poi_longitude": "-81.8668946",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c329-7350-8e98-0dec09040ee0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c329-7350-8e98-0dec09040ee0",
        "storage_key": "property/6767906449167729/01a03951-c329-7350-8e98-0dec09040ee0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJgz7h6-FB24gRsn_ni6rDu5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_036b243aa688e225b8e4c5b6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "LeeTran Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3401 Metro Pkwy, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-bee4-7348-9a99-8563cb7b335d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-bee4-7348-9a99-8563cb7b335d",
        "storage_key": "property/6767906449167729/01a0394e-bee4-7348-9a99-8563cb7b335d.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.rideleetran.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=461059624251901655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leetran-headquarters",
      "poi_latitude": "26.6174565",
      "poi_longitude": "-81.85830469999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 239-533-8726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcq6p6Jq24gR10bPE0kDZgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_09ae3da44111cbb5fc15b222",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Edison Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Myers, FL 33907, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b0a8-70a9-9775-2db71566b01e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b0a8-70a9-9775-2db71566b01e",
        "storage_key": "property/6767906449167729/01a03951-b0a8-70a9-9775-2db71566b01e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.leegov.com/leetran",
      "poi_directions_map_url": "https://maps.google.com/?cid=16983671238703168325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edison-mall",
      "poi_latitude": "26.599332",
      "poi_longitude": "-81.86671",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 239-533-8726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c329-7350-8e98-0dec09040ee0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c329-7350-8e98-0dec09040ee0",
        "storage_key": "property/6767906449167729/01a03951-c329-7350-8e98-0dec09040ee0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSG25ydA24gRRbvrHAIfsus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_d4af27b44464f59919d20953",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Southwest Florida International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "11000 Terminal Access Rd, Fort Myers, FL 33913, USA",
      "poi_short_description": "Regional airport featuring an array of works by local artists plus eateries & shops.",
      "poi_long_description": "Regional airport featuring an array of works by local artists plus eateries & shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b974-74e1-9fb0-5ef233b2367c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b974-74e1-9fb0-5ef233b2367c",
        "storage_key": "property/6767906449167729/01a03951-b974-74e1-9fb0-5ef233b2367c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrsw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18165443980804050502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-florida-international-airport",
      "poi_latitude": "26.5318723",
      "poi_longitude": "-81.75956459999999",
      "poi_miles_from_property": "16.9 mi",
      "poi_walking_minutes": "6 hours 11 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 239-590-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-cdc2-7640-95ae-71125be62526.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-cdc2-7640-95ae-71125be62526",
        "storage_key": "property/6767906449167729/01a0394e-cdc2-7640-95ae-71125be62526.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQUlvz8T24gRRk4VTw6fGPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_fec6ea16cbeb721b4b1013da",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Beach Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11101 Summerlin Square Dr, Fort Myers Beach, FL 33931, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b44b-74b7-af88-b454a99300e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b44b-74b7-af88-b454a99300e6",
        "storage_key": "property/6767906449167729/01a03951-b44b-74b7-af88-b454a99300e6.webp",
        "width": 1242,
        "height": 918
      },
      "poi_business_url": "https://www.fortmyersbeach.org/trolleyinfo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8368671831704318645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beach-park--ride",
      "poi_latitude": "26.4923141",
      "poi_longitude": "-81.9359139",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c328-7084-965a-05cc6623ea0c",
        "storage_key": "property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJj6j3oL4-24gRtbKNGrF-I3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_4fda7237c76fbcf418217f2d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Cape Coral Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Cape Coral, FL 33904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b52b-771e-9251-f8f0ecbf6930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b52b-771e-9251-f8f0ecbf6930",
        "storage_key": "property/6767906449167729/01a03951-b52b-771e-9251-f8f0ecbf6930.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8782771490280270159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cape-coral-transfer-center",
      "poi_latitude": "26.563556",
      "poi_longitude": "-81.95643799999999",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c328-7084-965a-05cc6623ea0c",
        "storage_key": "property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3etsf6w424gRT2mVJSOs4nk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_5f9cdf27a11461b325d9c19d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Bell Tower",
      "poi_type": "Shopping & Retail",
      "poi_address": "13499 S Cleveland Ave, Fort Myers, FL 33907, USA",
      "poi_short_description": "Modern, open-air mall with fountains & specialty stores, plus diverse restaurants & a movie theater.",
      "poi_long_description": "Modern, open-air mall with fountains & specialty stores, plus diverse restaurants & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b52c-738b-b9ff-c513cb5fde5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b52c-738b-b9ff-c513cb5fde5a",
        "storage_key": "property/6767906449167729/01a03951-b52c-738b-b9ff-c513cb5fde5a.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://belltowerfl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12962765514009858488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell-tower",
      "poi_latitude": "26.5483398",
      "poi_longitude": "-81.8692035",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 239-489-1221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1842344b69a2",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1842344b69a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKUgjsOM_24gRuNE9KY7-5LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_432ef6ed3fc02f498bc7ff67",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "South Fort Myers Transfer/P&R",
      "poi_type": "Transportation & Transit",
      "poi_address": "Villas, FL 33907, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b6e9-770d-a617-3c7528a1b135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b6e9-770d-a617-3c7528a1b135",
        "storage_key": "property/6767906449167729/01a03951-b6e9-770d-a617-3c7528a1b135.webp",
        "width": 1280,
        "height": 935
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7657118644321416286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-fort-myers-transferpr",
      "poi_latitude": "26.549979",
      "poi_longitude": "-81.87307",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c328-7084-965a-05cc6623ea0c",
        "storage_key": "property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJjW23X-Q_24gRXnTMfdaMQ2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_cf38f758bc4f4bfd19abde49",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Lehigh Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lehigh Acres, FL 33972, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b85f-77fa-8488-d630b91555ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b85f-77fa-8488-d630b91555ff",
        "storage_key": "property/6767906449167729/01a03951-b85f-77fa-8488-d630b91555ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13862579541195326120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-park--ride",
      "poi_latitude": "26.620481",
      "poi_longitude": "-81.64718599999999",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 40 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c328-7084-965a-05cc6623ea0c",
        "storage_key": "property/6767906449167729/01a03951-c328-7084-965a-05cc6623ea0c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJLRJRS7Vz24gRqIKLR6XGYcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_37dbc40be89fb86160413f29",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Lee Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2776 Cleveland Ave, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-b339-74f6-8067-ab259d5b7440.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-b339-74f6-8067-ab259d5b7440",
        "storage_key": "property/6767906449167729/01a0394e-b339-74f6-8067-ab259d5b7440.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.leehealth.org/find-a-location/lee-memorial-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=6126078084332599267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lee-memorial-hospital",
      "poi_latitude": "26.6284093",
      "poi_longitude": "-81.87408049999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-343-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1f1202518170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1f1202518170",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1f1202518170.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyYe8ttB24gR4zfzco8zBFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_cb2352dfadeb1c5cbb90ce75",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Lee County Courthouse",
      "poi_type": "Education",
      "poi_address": "1700 Monroe St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ca.cjis20.org/About-The-Court/Locations/leecounty.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=185456128221917692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lee-county-courthouse",
      "poi_latitude": "26.641309",
      "poi_longitude": "-81.871466",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-461-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRbOHJp9B24gR_DEWtF3fkgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_329cf5670c02964224805d62",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Ft. Myers Division U.S. Courthouse & Federal Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2110 First St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b786-71c7-b3aa-68fb40ab177b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b786-71c7-b3aa-68fb40ab177b",
        "storage_key": "property/6767906449167729/01a03951-b786-71c7-b3aa-68fb40ab177b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flmd.uscourts.gov/locations/fort-myers",
      "poi_directions_map_url": "https://maps.google.com/?cid=6336268882825704931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ft-myers-division-us-courthouse--federal-building",
      "poi_latitude": "26.643128",
      "poi_longitude": "-81.871039",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-461-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-cdf8-76b2-bea4-aa2505583179.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-cdf8-76b2-bea4-aa2505583179",
        "storage_key": "property/6767906449167729/01a0394e-cdf8-76b2-bea4-aa2505583179.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5SbEluNB24gR4_UvWvry7lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_2c1df70f48505bdc31cf1ed7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Lee County Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2115 Second St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-b9ce-768e-a4fc-3c6bc9022858.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-b9ce-768e-a4fc-3c6bc9022858",
        "storage_key": "property/6767906449167729/01a03951-b9ce-768e-a4fc-3c6bc9022858.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leegov.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11941818930899805631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lee-county-administration",
      "poi_latitude": "26.6420299",
      "poi_longitude": "-81.869924",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-533-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-cdf8-76b2-bea4-aa2505583179.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-cdf8-76b2-bea4-aa2505583179",
        "storage_key": "property/6767906449167729/01a0394e-cdf8-76b2-bea4-aa2505583179.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_XdweNB24gRv2VRFAzduaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_2d325f413e4b5a359d40629c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "City of Fort Myers City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 Second St, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c299-755f-8d42-fc50a9012260.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0394e-c299-755f-8d42-fc50a9012260",
        "storage_key": "property/6767906449167729/01a0394e-c299-755f-8d42-fc50a9012260.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fortmyers.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3955999028989307373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-fort-myers-city-hall",
      "poi_latitude": "26.6420478",
      "poi_longitude": "-81.8690471",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-321-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-cdf8-76b2-bea4-aa2505583179.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-cdf8-76b2-bea4-aa2505583179",
        "storage_key": "property/6767906449167729/01a0394e-cdf8-76b2-bea4-aa2505583179.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9TUjteNB24gR7amyNiiI5jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_a2df6f238c7ffc6d5747a4c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "State Attorney",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 Main St, Fort Myers, FL 33901, USA",
      "poi_short_description": "Law firm providing a restroom and scheduling appointments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-bd0d-73d9-ab7e-76ca9a2ea982.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-bd0d-73d9-ab7e-76ca9a2ea982",
        "storage_key": "property/6767906449167729/01a03951-bd0d-73d9-ab7e-76ca9a2ea982.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5489799403706982454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-attorney",
      "poi_latitude": "26.6413124",
      "poi_longitude": "-81.871956",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 239-533-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-c9f7-7098-a76a-7ce3b42d4c85",
        "storage_key": "property/6767906449167729/01a0394e-c9f7-7098-a76a-7ce3b42d4c85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiaJGBORB24gRNiAbsnivL0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lawyer"
    },
    {
      "id": "ec_0741a8b153495a3bcfdc2822",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "Fort Myers Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2210 Widman Way, Fort Myers, FL 33901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-ba91-70cb-94ab-e750ba3f072c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-ba91-70cb-94ab-e750ba3f072c",
        "storage_key": "property/6767906449167729/01a03951-ba91-70cb-94ab-e750ba3f072c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17436837214942260367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-myers-police-department",
      "poi_latitude": "26.6395169",
      "poi_longitude": "-81.8682365",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 239-321-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-c329-7350-8e98-10631f4234a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03951-c329-7350-8e98-10631f4234a8",
        "storage_key": "property/6767906449167729/01a03951-c329-7350-8e98-10631f4234a8.webp",
        "width": 177,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eyYmuFB24gRj-zxChAX_PE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_6cc324ca9329a5f4359f5ab1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "HealthPark Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9981 S Healthpark Dr, Fort Myers, FL 33908, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-ba0c-71eb-91ea-12dc72b1ba71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-ba0c-71eb-91ea-12dc72b1ba71",
        "storage_key": "property/6767906449167729/01a03951-ba0c-71eb-91ea-12dc72b1ba71.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.leehealth.org/find-a-location/healthpark-medical-center?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13944199078338691807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "healthpark-medical-center",
      "poi_latitude": "26.5073603",
      "poi_longitude": "-81.9128638",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 239-343-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca09-7066-9545-1f1202518170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca09-7066-9545-1f1202518170",
        "storage_key": "property/6767906449167729/01a0394e-ca09-7066-9545-1f1202518170.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTdqcvc-24gR3wK1pS6_g8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_95a632a3b5f48c4bc576a259",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "poi_name": "The School District of Lee County",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2855 Colonial Blvd, Fort Myers, FL 33966, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a03951-baf8-7478-9768-72a6580d6006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03951-baf8-7478-9768-72a6580d6006",
        "storage_key": "property/6767906449167729/01a03951-baf8-7478-9768-72a6580d6006.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.leeschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=181753732823947082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-school-district-of-lee-county",
      "poi_latitude": "26.5997599",
      "poi_longitude": "-81.8538631",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 239-334-1102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0394e-ca30-704c-bed2-fba787ffc11a",
        "storage_key": "property/6767906449167729/01a0394e-ca30-704c-bed2-fba787ffc11a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr9Cuxo9q24gRSpeSmQ64hQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    }
  ],
  "office_hours": [],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "ec_33b89249c25be5c2d8fe8666",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167729/01a0394f-7eb7-76b9-9ea8-c99892e853b7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0394f-7eb7-76b9-9ea8-c99892e853b7",
        "storage_key": "property/6767906449167729/01a0394f-7eb7-76b9-9ea8-c99892e853b7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR,1BA - 1004SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=v66D2jSJMT8"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "rooftop-pool-apartments-fort-myers-vantage",
      "search_query": "rooftop pool apartments Fort Myers",
      "category": "Amenity",
      "h1_title": "Rooftop Pool Apartments in Fort Myers",
      "h2_subtitle": "Discover luxury living in Fort Myers with stunning rooftop pool apartments. Relax in style at Vantage's sky lounge, featuring top-notch amenities.",
      "page_copy": "Experience exclusive living at Vantage, where our rooftop pool apartments in Fort Myers offer breathtaking views and unmatched comfort. Soak up the sun in our luxurious rooftop pool, designed for relaxation and leisure. Beyond the pool, unwind in our rooftop sky lounge, offering a perfect blend of style and panorama.\n\nVantage provides a host of modern amenities, from tile showers with glass enclosures to convenient electric car charging stations. Step into your space and enjoy the sophisticated touch of wood-style flooring throughout. Situated in the heart of Fort Myers, Vantage combines city vibes with serene retreats, making it the ideal choice for those seeking an elevated living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Pool Apartments in Fort Myers",
      "seo_description": "Explore Vantage's rooftop pool apartments in Fort Myers. Enjoy a rooftop sky lounge, pool, and more luxury amenities. Discover the Vantage lifestyle today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-wash-lee-county-vantage",
      "search_query": "pet friendly apartments with dog wash Lee County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Wash",
      "h2_subtitle": "Find pet friendly apartments in Lee County that offer a convenient dog wash. Vantage welcomes pets with open arms and exceptional amenities.",
      "page_copy": "At Vantage, we understand how important your furry friends are, which is why we offer pet friendly apartments with a dedicated dog wash in Lee County. Located in the heart of Fort Myers, our community ensures that both pets and their owners are comfortable and cared for, with amenities designed to meet everyone's needs.\n\nOur spacious apartments are complemented by premium features like tile showers with glass enclosures and elegant wood-style flooring, giving you and your pet a luxurious living environment. The rooftop sky lounge and rooftop pool provide stunning views and places to unwind, further enhancing the lifestyle at Vantage. Join us and discover why pet owners love calling Vantage their home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Wash",
      "seo_description": "Explore pet friendly apartments with a dog wash in Lee County. Vantage offers luxury living and amenities for you and your furry friends!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-fort-myers-vantage",
      "search_query": "luxury apartments with in unit laundry Fort Myers FL",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Explore luxury apartments in Fort Myers, FL, featuring convenient in-unit laundry facilities. Vantage redefines comfort and style.",
      "page_copy": "Vantage offers the epitome of upscale living in Fort Myers, FL, with our luxury apartments featuring in-unit laundry facilities. This essential amenity provides the ultimate convenience, allowing you to manage your laundry needs in the comfort of your home. No more hassles or shared spaces — enjoy your private sanctuary at Vantage.\n\nAlongside in-unit laundry, Vantage boasts an array of upscale amenities including a rooftop pool, a sophisticated sky lounge, and wood-style flooring throughout each apartment. Our bathrooms are designed with modern elegance, featuring tile showers with glass enclosures. Discover the superior lifestyle waiting for you in Fort Myers at Vantage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry",
      "seo_description": "Vantage offers luxury apartments with in-unit laundry in Fort Myers, FL. Experience unmatched comfort and style today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "smart-home-apartments-near-33901-vantage",
      "search_query": "smart home apartments near 33901",
      "category": "Amenity",
      "h1_title": "Smart Home Apartments Near 33901",
      "h2_subtitle": "Discover smart home apartments near 33901 at Vantage. Elevate your living with cutting-edge technology in Fort Myers, FL.",
      "page_copy": "Situated conveniently near the 33901 area, Vantage offers smart home apartments that blend technology with elegance in Fort Myers, FL. Our state-of-the-art units are designed to simplify your life, ensuring comfort and convenience with a touch of modern tech.\n\nIn addition to smart home features, residents enjoy luxurious amenities such as a rooftop pool, wood-style flooring, and exquisitely designed bathrooms with tile showers and glass enclosures. Our electric car charging stations add another layer of convenience, making Vantage the ideal choice for a contemporary lifestyle near downtown Fort Myers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Apartments Near 33901",
      "seo_description": "Explore smart home apartments near the 33901 area at Vantage in Fort Myers, offering luxury amenities and modern convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "apartments-electric-car-charging-stations-fort-myers-vantage",
      "search_query": "apartments with electric car charging stations Fort Myers",
      "category": "Amenity",
      "h1_title": "Apartments with Electric Car Charging Stations",
      "h2_subtitle": "Find apartments with electric car charging stations in Fort Myers. Vantage provides eco-friendly amenities for modern living.",
      "page_copy": "Vantage stands out in Fort Myers by offering apartments with electric car charging stations, catering to the needs of eco-conscious residents. Our commitment to sustainability ensures that you have convenient access to charging facilities right where you live, making it easier than ever to maintain a green lifestyle.\n\nBeyond supporting eco-friendly living, our community offers luxurious amenities such as a rooftop sky lounge, a refreshing rooftop pool, and stylish wood-style flooring throughout the units. Bathrooms equipped with tile showers and glass enclosures further elevate your living experience. Choose Vantage for a sophisticated and sustainable lifestyle in Fort Myers, FL.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Electric Car Charging Stations",
      "seo_description": "Discover apartments with electric car charging stations at Vantage in Fort Myers. Enjoy modern, sustainable living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-fort-myers-fl-vantage",
      "search_query": "two bedroom apartments fort myers fl",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Fort Myers, FL",
      "h2_subtitle": "Explore spacious two bedroom apartments in Fort Myers, FL at Vantage. Experience comfort and luxury like never before.",
      "page_copy": "At Vantage in Fort Myers, FL, our two bedroom apartments offer ample living space combined with modern luxuries. Each unit is designed with premium features, including wood-style flooring and tile showers with glass enclosures, making it a perfect retreat after a long day.\n\nWhether you're enjoying views from the rooftop sky lounge or swimming in the rooftop pool, Vantage provides a lifestyle of both comfort and sophistication. With an electric car charging station on-site, our two bedroom apartments are ideal for those seeking convenience and eco-friendly amenity options in Fort Myers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Fort Myers, FL",
      "seo_description": "Discover spacious two bedroom apartments at Vantage in Fort Myers, FL. Enjoy luxury amenities and modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "apartments-near-cape-coral-hospital-fort-myers-vantage",
      "search_query": "apartments near Cape Coral Hospital Fort Myers",
      "category": "Hospital",
      "h1_title": "Apartments Near Cape Coral Hospital",
      "h2_subtitle": "Find stylish apartments near Cape Coral Hospital in Fort Myers. Vantage offers convenience and modern living.",
      "page_copy": "Vantage is ideally located for those seeking apartments near Cape Coral Hospital in Fort Myers. Our community ensures you're close to essential healthcare services while enjoying luxurious living. Each apartment boasts contemporary amenities, such as wood-style flooring and elegantly designed bathrooms with tile showers and glass enclosures.\n\nResidents at Vantage can relax in the rooftop sky lounge, swim in our rooftop pool, or charge their electric cars at our convenient station. This blend of location and luxury makes Vantage the perfect choice for anyone seeking proximity to Cape Coral Hospital without sacrificing comfort or style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cape Coral Hospital",
      "seo_description": "Explore apartments near Cape Coral Hospital at Vantage in Fort Myers. Enjoy luxury living and convenient healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167729",
      "source": "generator",
      "page_item_url": "apartments-near-centennial-park-fort-myers-vantage",
      "search_query": "apartments near Centennial Park Fort Myers",
      "category": "Park",
      "h1_title": "Apartments Near Centennial Park, Fort Myers",
      "h2_subtitle": "Discover beautiful apartments near Centennial Park in Fort Myers. Vantage offers proximity to nature and modern amenities.",
      "page_copy": "Located just a short distance from Centennial Park, Vantage provides the ideal setting for those who love the outdoors yet desire modern comforts. Our apartments allow you to enjoy the serene ambiance of the nearby park while experiencing luxury living. Inside, you'll find high-end features like wood-style flooring and tasteful tile showers with glass enclosures.\n\nVantage not only provides easy access to the natural beauty of Centennial Park but also offers top-tier amenities including a rooftop sky lounge, a sparkling rooftop pool, and an on-site electric car charging station. Revel in the perfect blend of nature and sophistication at Vantage, your new home in Fort Myers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Centennial Park, Fort Myers",
      "seo_description": "Find luxury apartments near Centennial Park at Vantage in Fort Myers. Enjoy nature and modern amenities in perfect harmony.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IklHMnIwTUxUWVZ0YTNVTGtTcCt2aUE9PSIsInZhbHVlIjoibkJ5dTR3cGhKSmg1cG9EcWEybEZOZz09IiwibWFjIjoiNWVjNTgyZjczNTUyMDRiZWZkMzViYWY0N2Q3MGY3YjE0YzdhNzhkODMxOWVlMjQ5ODhjZjc2OTJlMTlmMDU1OSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6IklHMnIwTUxUWVZ0YTNVTGtTcCt2aUE9PSIsInZhbHVlIjoibkJ5dTR3cGhKSmg1cG9EcWEybEZOZz09IiwibWFjIjoiNWVjNTgyZjczNTUyMDRiZWZkMzViYWY0N2Q3MGY3YjE0YzdhNzhkODMxOWVlMjQ5ODhjZjc2OTJlMTlmMDU1OSJ9",
  "custom_audioeye_site_id": "ad616f47-a8bb-4e50-82dc-1afba6cf6370",
  "custom_audioeye_site_hash": "5616ae8918e484aecf50f11d97526747"
};

export const generatedAt = '2026-08-25T17:17:49.855Z';
